var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _g, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 287,
    viewBox: "0 0 400 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 249.96H0V250.16H400V249.96Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92 262.832H333.424V263.032H359.92V262.832Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.976 265.008H258.024V265.208H264.976V265.008Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332.624 255.408H317.272V255.608H332.624V255.408Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.52 256.752H41.968V256.952H76.52V256.752Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7122 256.752H83.6482V256.952H88.7122V256.752Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.12 260.128H105.176V260.328H180.12V260.128Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 60.84V0.839996H47.2V242.44H59.2V17.688L102.544 12.8L102.736 13L102.936 12.752L124.472 10.352L124.712 10.624L124.968 10.296L136.8 8.984V60.84H124V67.24H151.2V60.84H139.2ZM77.2479 5.024L84.4479 12.44L69.6 14.112L77.2479 5.024ZM67.5359 12.8L60.528 3.24H75.6159L67.5359 12.8ZM78.856 3.24H93.6L86.496 11.072L78.856 3.24ZM136.8 4.24V6.576L134.928 6.784L136.8 4.24ZM132.848 5.6L130.696 3.28H134.56L132.848 5.6ZM127.536 3.28L124.584 6.984L121.2 3.28H127.536ZM118.04 3.28L114.48 7.744L110.576 3.28H118.04ZM107.448 3.28L102.584 9.408L96.8479 3.28H107.448ZM59.2 5.488L65.832 14.536L59.2 15.28V5.488ZM88.928 11.944L95.2 5.008L100.48 10.608L88.928 11.944ZM109.024 5.112L112.672 9.28L105.04 10.136L109.024 5.112ZM116.656 8.8L119.64 5.056L122.472 8.144L116.656 8.8ZM129.136 5.048L131.104 7.2L127.104 7.656L129.136 5.048Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72.84H95.1999V64.84H92.7999V72.84H76.7999V57.64H73.5999V224.84H115.2V62.44H112V72.84ZM92.7999 85.64H76.7999V76.84H92.7999V85.64ZM112 85.64H95.1999V76.84H112V85.64Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M362.376 249.64V208.712H358.88V189.208H353.76V121.4H346.36V112.648L330.576 105.28V96.456H328.384V121.4H325.32V189.208H322.264V153.552H313.952V135.176H311.632V189.208H305.32V168.648H301.16V163.392H291.536V145.456H286.264V132.768H279.784V114.288H277.472V132.768H270.992V145.456H265.72V163.392H256.096V168.648H251.944V189.208H247.016V163.392H237.392V107.832H234.328V101.712H213.768V107.832H209.392V148.08H191.888V152.016H185.328V155.08H191.888V170.832H173.52V118.336H169.576V107.176H161.048V67.584H158.64V107.176H152.52V118.336H116.608V114.664H114.424V139.6H111.36V140.032H109.52V164.976H106.456V171.752H99.984V153.376H97.664V197.128H95.088V178.752H92.768V207.408H91.352V186.848H87.2V181.6H77.576V163.656H72.304V150.976H65.824V132.488H63.512V150.976H57.032V163.656H51.76V181.6H42.136V186.848H37.984V206.968H37.232V207.408H35.176V249.64H362.376Z",
    fill: "#141E30",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 120.784H136.648V123.264H139.128V120.784Z",
    fill: "#F2F6F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 124.944H136.648V127.424H139.128V124.944Z",
    fill: "#F2F6F9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 141.568H136.648V144.048H139.128V141.568Z",
    fill: "#F2F6F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 145.72H136.648V148.2H139.128V145.72Z",
    fill: "#F2F6F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 149.88H136.648V152.36H139.128V149.88Z",
    fill: "#F2F6F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 162.344H136.648V164.824H139.128V162.344Z",
    fill: "#F2F6F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.128 166.504H136.648V168.984H139.128V166.504Z",
    fill: "#F2F6F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 137.408H140.584V139.888H143.064V137.408Z",
    fill: "#F2F6F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 141.568H140.584V144.048H143.064V141.568Z",
    fill: "#F2F6F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 145.72H140.584V148.2H143.064V145.72Z",
    fill: "#F2F6F9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 149.88H140.584V152.36H143.064V149.88Z",
    fill: "#F2F6F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 154.032H140.584V156.512H143.064V154.032Z",
    fill: "#F2F6F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 162.344H140.584V164.824H143.064V162.344Z",
    fill: "#F2F6F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M143.064 166.504H140.584V168.984H143.064V166.504Z",
    fill: "#F2F6F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147 120.784H144.52V123.264H147V120.784Z",
    fill: "#F2F6F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147 124.944H144.52V127.424H147V124.944Z",
    fill: "#F2F6F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147 129.096H144.52V131.576H147V129.096Z",
    fill: "#F2F6F9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M147 133.256H144.52V135.736H147V133.256Z",
    fill: "#F2F6F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147 137.408H144.52V139.888H147V137.408Z",
    fill: "#F2F6F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147 141.568H144.52V144.048H147V141.568Z",
    fill: "#F2F6F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M147 145.72H144.52V148.2H147V145.72Z",
    fill: "#F2F6F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M147 149.88H144.52V152.36H147V149.88Z",
    fill: "#F2F6F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147 154.032H144.52V156.512H147V154.032Z",
    fill: "#F2F6F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M147 158.192H144.52V160.672H147V158.192Z",
    fill: "#F2F6F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M147 166.504H144.52V168.984H147V166.504Z",
    fill: "#F2F6F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 120.784H148.456V123.264H150.936V120.784Z",
    fill: "#F2F6F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 124.944H148.456V127.424H150.936V124.944Z",
    fill: "#F2F6F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 129.096H148.456V131.576H150.936V129.096Z",
    fill: "#F2F6F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 133.256H148.456V135.736H150.936V133.256Z",
    fill: "#F2F6F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 137.408H148.456V139.888H150.936V137.408Z",
    fill: "#F2F6F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 141.568H148.456V144.048H150.936V141.568Z",
    fill: "#F2F6F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 145.72H148.456V148.2H150.936V145.72Z",
    fill: "#F2F6F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M150.936 183.128H148.456V185.608H150.936V183.128Z",
    fill: "#F2F6F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 120.784H152.392V123.264H154.872V120.784Z",
    fill: "#F2F6F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 124.944H152.392V127.424H154.872V124.944Z",
    fill: "#F2F6F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 129.096H152.392V131.576H154.872V129.096Z",
    fill: "#F2F6F9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 133.256H152.392V135.736H154.872V133.256Z",
    fill: "#F2F6F9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 137.408H152.392V139.888H154.872V137.408Z",
    fill: "#F2F6F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 141.568H152.392V144.048H154.872V141.568Z",
    fill: "#F2F6F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 145.72H152.392V148.2H154.872V145.72Z",
    fill: "#F2F6F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 149.88H152.392V152.36H154.872V149.88Z",
    fill: "#F2F6F9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 174.816H152.392V177.296H154.872V174.816Z",
    fill: "#F2F6F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 178.968H152.392V181.448H154.872V178.968Z",
    fill: "#F2F6F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 183.128H152.392V185.608H154.872V183.128Z",
    fill: "#F2F6F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 187.28H152.392V189.76H154.872V187.28Z",
    fill: "#F2F6F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M154.872 203.912H152.392V206.392H154.872V203.912Z",
    fill: "#F2F6F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 120.784H156.336V123.264H158.816V120.784Z",
    fill: "#F2F6F9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 124.944H156.336V127.424H158.816V124.944Z",
    fill: "#F2F6F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 129.096H156.336V131.576H158.816V129.096Z",
    fill: "#F2F6F9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 133.256H156.336V135.736H158.816V133.256Z",
    fill: "#F2F6F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 137.408H156.336V139.888H158.816V137.408Z",
    fill: "#F2F6F9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 141.568H156.336V144.048H158.816V141.568Z",
    fill: "#F2F6F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 145.72H156.336V148.2H158.816V145.72Z",
    fill: "#F2F6F9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 149.88H156.336V152.36H158.816V149.88Z",
    fill: "#F2F6F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 154.032H156.336V156.512H158.816V154.032Z",
    fill: "#F2F6F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 158.192H156.336V160.672H158.816V158.192Z",
    fill: "#F2F6F9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 170.656H156.336V173.136H158.816V170.656Z",
    fill: "#F2F6F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 174.816H156.336V177.296H158.816V174.816Z",
    fill: "#F2F6F9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 178.968H156.336V181.448H158.816V178.968Z",
    fill: "#F2F6F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 183.128H156.336V185.608H158.816V183.128Z",
    fill: "#F2F6F9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 187.28H156.336V189.76H158.816V187.28Z",
    fill: "#F2F6F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M158.816 203.912H156.336V206.392H158.816V203.912Z",
    fill: "#F2F6F9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 120.784H160.272V123.264H162.752V120.784Z",
    fill: "#F2F6F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 124.944H160.272V127.424H162.752V124.944Z",
    fill: "#F2F6F9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 129.096H160.272V131.576H162.752V129.096Z",
    fill: "#F2F6F9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 133.256H160.272V135.736H162.752V133.256Z",
    fill: "#F2F6F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 137.408H160.272V139.888H162.752V137.408Z",
    fill: "#F2F6F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 141.568H160.272V144.048H162.752V141.568Z",
    fill: "#F2F6F9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 145.72H160.272V148.2H162.752V145.72Z",
    fill: "#F2F6F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 149.88H160.272V152.36H162.752V149.88Z",
    fill: "#F2F6F9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 154.032H160.272V156.512H162.752V154.032Z",
    fill: "#F2F6F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 158.192H160.272V160.672H162.752V158.192Z",
    fill: "#F2F6F9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 162.344H160.272V164.824H162.752V162.344Z",
    fill: "#F2F6F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 166.504H160.272V168.984H162.752V166.504Z",
    fill: "#F2F6F9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 170.656H160.272V173.136H162.752V170.656Z",
    fill: "#F2F6F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 174.816H160.272V177.296H162.752V174.816Z",
    fill: "#F2F6F9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 178.968H160.272V181.448H162.752V178.968Z",
    fill: "#F2F6F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 183.128H160.272V185.608H162.752V183.128Z",
    fill: "#F2F6F9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 187.28H160.272V189.76H162.752V187.28Z",
    fill: "#F2F6F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M162.752 191.44H160.272V193.92H162.752V191.44Z",
    fill: "#F2F6F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 120.784H164.208V123.264H166.688V120.784Z",
    fill: "#F2F6F9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 124.944H164.208V127.424H166.688V124.944Z",
    fill: "#F2F6F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 129.096H164.208V131.576H166.688V129.096Z",
    fill: "#F2F6F9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 133.256H164.208V135.736H166.688V133.256Z",
    fill: "#F2F6F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 137.408H164.208V139.888H166.688V137.408Z",
    fill: "#F2F6F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 141.568H164.208V144.048H166.688V141.568Z",
    fill: "#F2F6F9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 145.72H164.208V148.2H166.688V145.72Z",
    fill: "#F2F6F9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 149.88H164.208V152.36H166.688V149.88Z",
    fill: "#F2F6F9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 154.032H164.208V156.512H166.688V154.032Z",
    fill: "#F2F6F9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 158.192H164.208V160.672H166.688V158.192Z",
    fill: "#F2F6F9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 170.656H164.208V173.136H166.688V170.656Z",
    fill: "#F2F6F9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 174.816H164.208V177.296H166.688V174.816Z",
    fill: "#F2F6F9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 178.968H164.208V181.448H166.688V178.968Z",
    fill: "#F2F6F9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M166.688 183.128H164.208V185.608H166.688V183.128Z",
    fill: "#F2F6F9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 120.784H168.144V123.264H170.624V120.784Z",
    fill: "#F2F6F9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 124.944H168.144V127.424H170.624V124.944Z",
    fill: "#F2F6F9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 129.096H168.144V131.576H170.624V129.096Z",
    fill: "#F2F6F9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 133.256H168.144V135.736H170.624V133.256Z",
    fill: "#F2F6F9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 137.408H168.144V139.888H170.624V137.408Z",
    fill: "#F2F6F9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 141.568H168.144V144.048H170.624V141.568Z",
    fill: "#F2F6F9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 145.72H168.144V148.2H170.624V145.72Z",
    fill: "#F2F6F9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 149.88H168.144V152.36H170.624V149.88Z",
    fill: "#F2F6F9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 154.032H168.144V156.512H170.624V154.032Z",
    fill: "#F2F6F9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 158.192H168.144V160.672H170.624V158.192Z",
    fill: "#F2F6F9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 170.656H168.144V173.136H170.624V170.656Z",
    fill: "#F2F6F9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 174.816H168.144V177.296H170.624V174.816Z",
    fill: "#F2F6F9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M170.624 178.968H168.144V181.448H170.624V178.968Z",
    fill: "#F2F6F9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 109.992H212.472V112.472H214.952V109.992Z",
    fill: "#F2F6F9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 114.152H212.472V116.632H214.952V114.152Z",
    fill: "#F2F6F9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 118.304H212.472V120.784H214.952V118.304Z",
    fill: "#F2F6F9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 122.464H212.472V124.944H214.952V122.464Z",
    fill: "#F2F6F9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 126.616H212.472V129.096H214.952V126.616Z",
    fill: "#F2F6F9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 130.776H212.472V133.256H214.952V130.776Z",
    fill: "#F2F6F9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 134.928H212.472V137.408H214.952V134.928Z",
    fill: "#F2F6F9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 139.088H212.472V141.568H214.952V139.088Z",
    fill: "#F2F6F9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 151.56H212.472V154.04H214.952V151.56Z",
    fill: "#F2F6F9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M214.952 155.712H212.472V158.192H214.952V155.712Z",
    fill: "#F2F6F9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 109.992H216.416V112.472H218.896V109.992Z",
    fill: "#F2F6F9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 114.152H216.416V116.632H218.896V114.152Z",
    fill: "#F2F6F9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 118.304H216.416V120.784H218.896V118.304Z",
    fill: "#F2F6F9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 122.464H216.416V124.944H218.896V122.464Z",
    fill: "#F2F6F9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 126.616H216.416V129.096H218.896V126.616Z",
    fill: "#F2F6F9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 130.776H216.416V133.256H218.896V130.776Z",
    fill: "#F2F6F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 134.928H216.416V137.408H218.896V134.928Z",
    fill: "#F2F6F9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 139.088H216.416V141.568H218.896V139.088Z",
    fill: "#F2F6F9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M218.896 155.712H216.416V158.192H218.896V155.712Z",
    fill: "#F2F6F9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 109.992H220.352V112.472H222.832V109.992Z",
    fill: "#F2F6F9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 114.152H220.352V116.632H222.832V114.152Z",
    fill: "#F2F6F9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 118.304H220.352V120.784H222.832V118.304Z",
    fill: "#F2F6F9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 122.464H220.352V124.944H222.832V122.464Z",
    fill: "#F2F6F9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 126.616H220.352V129.096H222.832V126.616Z",
    fill: "#F2F6F9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 130.776H220.352V133.256H222.832V130.776Z",
    fill: "#F2F6F9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 134.928H220.352V137.408H222.832V134.928Z",
    fill: "#F2F6F9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M222.832 139.088H220.352V141.568H222.832V139.088Z",
    fill: "#F2F6F9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 109.992H224.288V112.472H226.768V109.992Z",
    fill: "#F2F6F9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 114.152H224.288V116.632H226.768V114.152Z",
    fill: "#F2F6F9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 118.304H224.288V120.784H226.768V118.304Z",
    fill: "#F2F6F9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 122.464H224.288V124.944H226.768V122.464Z",
    fill: "#F2F6F9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 126.616H224.288V129.096H226.768V126.616Z",
    fill: "#F2F6F9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 130.776H224.288V133.256H226.768V130.776Z",
    fill: "#F2F6F9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 139.088H224.288V141.568H226.768V139.088Z",
    fill: "#F2F6F9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 143.24H224.288V145.72H226.768V143.24Z",
    fill: "#F2F6F9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 155.712H224.288V158.192H226.768V155.712Z",
    fill: "#F2F6F9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 159.872H224.288V162.352H226.768V159.872Z",
    fill: "#F2F6F9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 164.024H224.288V166.504H226.768V164.024Z",
    fill: "#F2F6F9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 168.184H224.288V170.664H226.768V168.184Z",
    fill: "#F2F6F9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 172.336H224.288V174.816H226.768V172.336Z",
    fill: "#F2F6F9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 176.496H224.288V178.976H226.768V176.496Z",
    fill: "#F2F6F9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 180.648H224.288V183.128H226.768V180.648Z",
    fill: "#F2F6F9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 109.992H228.224V112.472H230.704V109.992Z",
    fill: "#F2F6F9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 114.152H228.224V116.632H230.704V114.152Z",
    fill: "#F2F6F9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 118.304H228.224V120.784H230.704V118.304Z",
    fill: "#F2F6F9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 122.464H228.224V124.944H230.704V122.464Z",
    fill: "#F2F6F9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 126.616H228.224V129.096H230.704V126.616Z",
    fill: "#F2F6F9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 130.776H228.224V133.256H230.704V130.776Z",
    fill: "#F2F6F9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 143.24H228.224V145.72H230.704V143.24Z",
    fill: "#F2F6F9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 147.4H228.224V149.88H230.704V147.4Z",
    fill: "#F2F6F9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 151.56H228.224V154.04H230.704V151.56Z",
    fill: "#F2F6F9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 155.712H228.224V158.192H230.704V155.712Z",
    fill: "#F2F6F9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 159.872H228.224V162.352H230.704V159.872Z",
    fill: "#F2F6F9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 164.024H228.224V166.504H230.704V164.024Z",
    fill: "#F2F6F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 168.184H228.224V170.664H230.704V168.184Z",
    fill: "#F2F6F9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 172.336H228.224V174.816H230.704V172.336Z",
    fill: "#F2F6F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 176.496H228.224V178.976H230.704V176.496Z",
    fill: "#F2F6F9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 180.648H228.224V183.128H230.704V180.648Z",
    fill: "#F2F6F9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 184.808H228.224V187.288H230.704V184.808Z",
    fill: "#F2F6F9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M230.704 193.12H228.224V195.6H230.704V193.12Z",
    fill: "#F2F6F9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 109.992H232.16V112.472H234.64V109.992Z",
    fill: "#F2F6F9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 114.152H232.16V116.632H234.64V114.152Z",
    fill: "#F2F6F9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 118.304H232.16V120.784H234.64V118.304Z",
    fill: "#F2F6F9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 122.464H232.16V124.944H234.64V122.464Z",
    fill: "#F2F6F9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 126.616H232.16V129.096H234.64V126.616Z",
    fill: "#F2F6F9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 130.776H232.16V133.256H234.64V130.776Z",
    fill: "#F2F6F9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 143.24H232.16V145.72H234.64V143.24Z",
    fill: "#F2F6F9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 147.4H232.16V149.88H234.64V147.4Z",
    fill: "#F2F6F9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 151.56H232.16V154.04H234.64V151.56Z",
    fill: "#F2F6F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 155.712H232.16V158.192H234.64V155.712Z",
    fill: "#F2F6F9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 168.184H232.16V170.664H234.64V168.184Z",
    fill: "#F2F6F9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 172.336H232.16V174.816H234.64V172.336Z",
    fill: "#F2F6F9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 176.496H232.16V178.976H234.64V176.496Z",
    fill: "#F2F6F9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 180.648H232.16V183.128H234.64V180.648Z",
    fill: "#F2F6F9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 184.808H232.16V187.288H234.64V184.808Z",
    fill: "#F2F6F9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 193.12H232.16V195.6H234.64V193.12Z",
    fill: "#F2F6F9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M234.64 197.272H232.16V199.752H234.64V197.272Z",
    fill: "#F2F6F9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 148.64H267.888V151.12H270.368V148.64Z",
    fill: "#F2F6F9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 152.792H267.888V155.272H270.368V152.792Z",
    fill: "#F2F6F9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 156.952H267.888V159.432H270.368V156.952Z",
    fill: "#F2F6F9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 161.104H267.888V163.584H270.368V161.104Z",
    fill: "#F2F6F9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 165.264H267.888V167.744H270.368V165.264Z",
    fill: "#F2F6F9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 169.424H267.888V171.904H270.368V169.424Z",
    fill: "#F2F6F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 173.576H267.888V176.056H270.368V173.576Z",
    fill: "#F2F6F9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 186.048H267.888V188.528H270.368V186.048Z",
    fill: "#F2F6F9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 190.2H267.888V192.68H270.368V190.2Z",
    fill: "#F2F6F9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M270.368 194.36H267.888V196.84H270.368V194.36Z",
    fill: "#F2F6F9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 148.64H271.824V151.12H274.304V148.64Z",
    fill: "#F2F6F9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 152.792H271.824V155.272H274.304V152.792Z",
    fill: "#F2F6F9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 156.952H271.824V159.432H274.304V156.952Z",
    fill: "#F2F6F9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 161.104H271.824V163.584H274.304V161.104Z",
    fill: "#F2F6F9"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 165.264H271.824V167.744H274.304V165.264Z",
    fill: "#F2F6F9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 169.424H271.824V171.904H274.304V169.424Z",
    fill: "#F2F6F9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 173.576H271.824V176.056H274.304V173.576Z",
    fill: "#F2F6F9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 148.64H275.768V151.12H278.248V148.64Z",
    fill: "#F2F6F9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 152.792H275.768V155.272H278.248V152.792Z",
    fill: "#F2F6F9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 156.952H275.768V159.432H278.248V156.952Z",
    fill: "#F2F6F9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 161.104H275.768V163.584H278.248V161.104Z",
    fill: "#F2F6F9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 165.264H275.768V167.744H278.248V165.264Z",
    fill: "#F2F6F9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 169.424H275.768V171.904H278.248V169.424Z",
    fill: "#F2F6F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M278.248 173.576H275.768V176.056H278.248V173.576Z",
    fill: "#F2F6F9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 148.64H279.704V151.12H282.184V148.64Z",
    fill: "#F2F6F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 152.792H279.704V155.272H282.184V152.792Z",
    fill: "#F2F6F9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 156.952H279.704V159.432H282.184V156.952Z",
    fill: "#F2F6F9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 161.104H279.704V163.584H282.184V161.104Z",
    fill: "#F2F6F9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 165.264H279.704V167.744H282.184V165.264Z",
    fill: "#F2F6F9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 169.424H279.704V171.904H282.184V169.424Z",
    fill: "#F2F6F9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 173.576H279.704V176.056H282.184V173.576Z",
    fill: "#F2F6F9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 177.736H279.704V180.216H282.184V177.736Z",
    fill: "#F2F6F9"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 181.888H279.704V184.368H282.184V181.888Z",
    fill: "#F2F6F9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 186.048H279.704V188.528H282.184V186.048Z",
    fill: "#F2F6F9"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M282.184 190.2H279.704V192.68H282.184V190.2Z",
    fill: "#F2F6F9"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 148.64H283.64V151.12H286.12V148.64Z",
    fill: "#F2F6F9"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 152.792H283.64V155.272H286.12V152.792Z",
    fill: "#F2F6F9"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 156.952H283.64V159.432H286.12V156.952Z",
    fill: "#F2F6F9"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 161.104H283.64V163.584H286.12V161.104Z",
    fill: "#F2F6F9"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 165.264H283.64V167.744H286.12V165.264Z",
    fill: "#F2F6F9"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 169.424H283.64V171.904H286.12V169.424Z",
    fill: "#F2F6F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 173.576H283.64V176.056H286.12V173.576Z",
    fill: "#F2F6F9"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 177.736H283.64V180.216H286.12V177.736Z",
    fill: "#F2F6F9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 181.888H283.64V184.368H286.12V181.888Z",
    fill: "#F2F6F9"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 186.048H283.64V188.528H286.12V186.048Z",
    fill: "#F2F6F9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 190.2H283.64V192.68H286.12V190.2Z",
    fill: "#F2F6F9"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 194.36H283.64V196.84H286.12V194.36Z",
    fill: "#F2F6F9"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 206.824H283.64V209.304H286.12V206.824Z",
    fill: "#F2F6F9"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M286.12 210.984H283.64V213.464H286.12V210.984Z",
    fill: "#F2F6F9"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 148.64H287.576V151.12H290.056V148.64Z",
    fill: "#F2F6F9"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 152.792H287.576V155.272H290.056V152.792Z",
    fill: "#F2F6F9"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 156.952H287.576V159.432H290.056V156.952Z",
    fill: "#F2F6F9"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 169.424H287.576V171.904H290.056V169.424Z",
    fill: "#F2F6F9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 173.576H287.576V176.056H290.056V173.576Z",
    fill: "#F2F6F9"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 177.736H287.576V180.216H290.056V177.736Z",
    fill: "#F2F6F9"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 181.888H287.576V184.368H290.056V181.888Z",
    fill: "#F2F6F9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 186.048H287.576V188.528H290.056V186.048Z",
    fill: "#F2F6F9"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 190.2H287.576V192.68H290.056V190.2Z",
    fill: "#F2F6F9"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 194.36H287.576V196.84H290.056V194.36Z",
    fill: "#F2F6F9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 206.824H287.576V209.304H290.056V206.824Z",
    fill: "#F2F6F9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 210.984H287.576V213.464H290.056V210.984Z",
    fill: "#F2F6F9"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M290.056 215.136H287.576V217.616H290.056V215.136Z",
    fill: "#F2F6F9"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 123.704H328.848V126.184H331.328V123.704Z",
    fill: "#F2F6F9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 127.856H328.848V130.336H331.328V127.856Z",
    fill: "#F2F6F9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 132.016H328.848V134.496H331.328V132.016Z",
    fill: "#F2F6F9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 136.168H328.848V138.648H331.328V136.168Z",
    fill: "#F2F6F9"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 140.328H328.848V142.808H331.328V140.328Z",
    fill: "#F2F6F9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 144.48H328.848V146.96H331.328V144.48Z",
    fill: "#F2F6F9"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 148.64H328.848V151.12H331.328V148.64Z",
    fill: "#F2F6F9"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 152.792H328.848V155.272H331.328V152.792Z",
    fill: "#F2F6F9"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 156.952H328.848V159.432H331.328V156.952Z",
    fill: "#F2F6F9"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 161.104H328.848V163.584H331.328V161.104Z",
    fill: "#F2F6F9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 165.264H328.848V167.744H331.328V165.264Z",
    fill: "#F2F6F9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 169.424H328.848V171.904H331.328V169.424Z",
    fill: "#F2F6F9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 173.576H328.848V176.056H331.328V173.576Z",
    fill: "#F2F6F9"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 177.736H328.848V180.216H331.328V177.736Z",
    fill: "#F2F6F9"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 181.888H328.848V184.368H331.328V181.888Z",
    fill: "#F2F6F9"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 186.048H328.848V188.528H331.328V186.048Z",
    fill: "#F2F6F9"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 190.2H328.848V192.68H331.328V190.2Z",
    fill: "#F2F6F9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 194.36H328.848V196.84H331.328V194.36Z",
    fill: "#F2F6F9"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 198.512H328.848V200.992H331.328V198.512Z",
    fill: "#F2F6F9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 202.672H328.848V205.152H331.328V202.672Z",
    fill: "#F2F6F9"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 206.824H328.848V209.304H331.328V206.824Z",
    fill: "#F2F6F9"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 210.984H328.848V213.464H331.328V210.984Z",
    fill: "#F2F6F9"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M331.328 215.136H328.848V217.616H331.328V215.136Z",
    fill: "#F2F6F9"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 123.704H332.784V126.184H335.264V123.704Z",
    fill: "#F2F6F9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 127.856H332.784V130.336H335.264V127.856Z",
    fill: "#F2F6F9"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 132.016H332.784V134.496H335.264V132.016Z",
    fill: "#F2F6F9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 136.168H332.784V138.648H335.264V136.168Z",
    fill: "#F2F6F9"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 140.328H332.784V142.808H335.264V140.328Z",
    fill: "#F2F6F9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 144.48H332.784V146.96H335.264V144.48Z",
    fill: "#F2F6F9"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 148.64H332.784V151.12H335.264V148.64Z",
    fill: "#F2F6F9"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 152.792H332.784V155.272H335.264V152.792Z",
    fill: "#F2F6F9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 156.952H332.784V159.432H335.264V156.952Z",
    fill: "#F2F6F9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 161.104H332.784V163.584H335.264V161.104Z",
    fill: "#F2F6F9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 165.264H332.784V167.744H335.264V165.264Z",
    fill: "#F2F6F9"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 169.424H332.784V171.904H335.264V169.424Z",
    fill: "#F2F6F9"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 173.576H332.784V176.056H335.264V173.576Z",
    fill: "#F2F6F9"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 177.736H332.784V180.216H335.264V177.736Z",
    fill: "#F2F6F9"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 181.888H332.784V184.368H335.264V181.888Z",
    fill: "#F2F6F9"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 186.048H332.784V188.528H335.264V186.048Z",
    fill: "#F2F6F9"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 190.2H332.784V192.68H335.264V190.2Z",
    fill: "#F2F6F9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 194.36H332.784V196.84H335.264V194.36Z",
    fill: "#F2F6F9"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M335.264 198.512H332.784V200.992H335.264V198.512Z",
    fill: "#F2F6F9"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 123.704H336.72V126.184H339.2V123.704Z",
    fill: "#F2F6F9"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 127.856H336.72V130.336H339.2V127.856Z",
    fill: "#F2F6F9"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 132.016H336.72V134.496H339.2V132.016Z",
    fill: "#F2F6F9"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 136.168H336.72V138.648H339.2V136.168Z",
    fill: "#F2F6F9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 140.328H336.72V142.808H339.2V140.328Z",
    fill: "#F2F6F9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 144.48H336.72V146.96H339.2V144.48Z",
    fill: "#F2F6F9"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 148.64H336.72V151.12H339.2V148.64Z",
    fill: "#F2F6F9"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 152.792H336.72V155.272H339.2V152.792Z",
    fill: "#F2F6F9"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 156.952H336.72V159.432H339.2V156.952Z",
    fill: "#F2F6F9"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 161.104H336.72V163.584H339.2V161.104Z",
    fill: "#F2F6F9"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 165.264H336.72V167.744H339.2V165.264Z",
    fill: "#F2F6F9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 169.424H336.72V171.904H339.2V169.424Z",
    fill: "#F2F6F9"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 173.576H336.72V176.056H339.2V173.576Z",
    fill: "#F2F6F9"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 177.736H336.72V180.216H339.2V177.736Z",
    fill: "#F2F6F9"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 181.888H336.72V184.368H339.2V181.888Z",
    fill: "#F2F6F9"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 186.048H336.72V188.528H339.2V186.048Z",
    fill: "#F2F6F9"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 190.2H336.72V192.68H339.2V190.2Z",
    fill: "#F2F6F9"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 194.36H336.72V196.84H339.2V194.36Z",
    fill: "#F2F6F9"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 198.512H336.72V200.992H339.2V198.512Z",
    fill: "#F2F6F9"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 123.704H340.656V126.184H343.136V123.704Z",
    fill: "#F2F6F9"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 127.856H340.656V130.336H343.136V127.856Z",
    fill: "#F2F6F9"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 132.016H340.656V134.496H343.136V132.016Z",
    fill: "#F2F6F9"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 136.168H340.656V138.648H343.136V136.168Z",
    fill: "#F2F6F9"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 140.328H340.656V142.808H343.136V140.328Z",
    fill: "#F2F6F9"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 144.48H340.656V146.96H343.136V144.48Z",
    fill: "#F2F6F9"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 148.64H340.656V151.12H343.136V148.64Z",
    fill: "#F2F6F9"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 152.792H340.656V155.272H343.136V152.792Z",
    fill: "#F2F6F9"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 156.952H340.656V159.432H343.136V156.952Z",
    fill: "#F2F6F9"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 161.104H340.656V163.584H343.136V161.104Z",
    fill: "#F2F6F9"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 165.264H340.656V167.744H343.136V165.264Z",
    fill: "#F2F6F9"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 169.424H340.656V171.904H343.136V169.424Z",
    fill: "#F2F6F9"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 173.576H340.656V176.056H343.136V173.576Z",
    fill: "#F2F6F9"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 177.736H340.656V180.216H343.136V177.736Z",
    fill: "#F2F6F9"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M343.136 181.888H340.656V184.368H343.136V181.888Z",
    fill: "#F2F6F9"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 123.704H344.592V126.184H347.072V123.704Z",
    fill: "#F2F6F9"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 127.856H344.592V130.336H347.072V127.856Z",
    fill: "#F2F6F9"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 132.016H344.592V134.496H347.072V132.016Z",
    fill: "#F2F6F9"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 136.168H344.592V138.648H347.072V136.168Z",
    fill: "#F2F6F9"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 140.328H344.592V142.808H347.072V140.328Z",
    fill: "#F2F6F9"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 144.48H344.592V146.96H347.072V144.48Z",
    fill: "#F2F6F9"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 148.64H344.592V151.12H347.072V148.64Z",
    fill: "#F2F6F9"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 152.792H344.592V155.272H347.072V152.792Z",
    fill: "#F2F6F9"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 156.952H344.592V159.432H347.072V156.952Z",
    fill: "#F2F6F9"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 161.104H344.592V163.584H347.072V161.104Z",
    fill: "#F2F6F9"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 165.264H344.592V167.744H347.072V165.264Z",
    fill: "#F2F6F9"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 169.424H344.592V171.904H347.072V169.424Z",
    fill: "#F2F6F9"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M347.072 173.576H344.592V176.056H347.072V173.576Z",
    fill: "#F2F6F9"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 123.704H348.536V126.184H351.016V123.704Z",
    fill: "#F2F6F9"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 127.856H348.536V130.336H351.016V127.856Z",
    fill: "#F2F6F9"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 132.016H348.536V134.496H351.016V132.016Z",
    fill: "#F2F6F9"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 136.168H348.536V138.648H351.016V136.168Z",
    fill: "#F2F6F9"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 140.328H348.536V142.808H351.016V140.328Z",
    fill: "#F2F6F9"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 144.48H348.536V146.96H351.016V144.48Z",
    fill: "#F2F6F9"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 148.64H348.536V151.12H351.016V148.64Z",
    fill: "#F2F6F9"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 152.792H348.536V155.272H351.016V152.792Z",
    fill: "#F2F6F9"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 156.952H348.536V159.432H351.016V156.952Z",
    fill: "#F2F6F9"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 161.104H348.536V163.584H351.016V161.104Z",
    fill: "#F2F6F9"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 165.264H348.536V167.744H351.016V165.264Z",
    fill: "#F2F6F9"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M351.016 169.424H348.536V171.904H351.016V169.424Z",
    fill: "#F2F6F9"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 154.032H59.208V156.512H61.688V154.032Z",
    fill: "#F2F6F9"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 158.192H59.208V160.672H61.688V158.192Z",
    fill: "#F2F6F9"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 162.344H59.208V164.824H61.688V162.344Z",
    fill: "#F2F6F9"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 166.504H59.208V168.984H61.688V166.504Z",
    fill: "#F2F6F9"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 170.656H59.208V173.136H61.688V170.656Z",
    fill: "#F2F6F9"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 174.816H59.208V177.296H61.688V174.816Z",
    fill: "#F2F6F9"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 178.968H59.208V181.448H61.688V178.968Z",
    fill: "#F2F6F9"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 183.128H59.208V185.608H61.688V183.128Z",
    fill: "#F2F6F9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 187.28H59.208V189.76H61.688V187.28Z",
    fill: "#F2F6F9"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 191.44H59.208V193.92H61.688V191.44Z",
    fill: "#F2F6F9"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 195.6H59.208V198.08H61.688V195.6Z",
    fill: "#F2F6F9"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 199.752H59.208V202.232H61.688V199.752Z",
    fill: "#F2F6F9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 203.912H59.208V206.392H61.688V203.912Z",
    fill: "#F2F6F9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 208.064H59.208V210.544H61.688V208.064Z",
    fill: "#F2F6F9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 212.224H59.208V214.704H61.688V212.224Z",
    fill: "#F2F6F9"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 216.376H59.208V218.856H61.688V216.376Z",
    fill: "#F2F6F9"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 220.536H59.208V223.016H61.688V220.536Z",
    fill: "#F2F6F9"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 224.688H59.208V227.168H61.688V224.688Z",
    fill: "#F2F6F9"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 228.848H59.208V231.328H61.688V228.848Z",
    fill: "#F2F6F9"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M61.688 233H59.208V235.48H61.688V233Z",
    fill: "#F2F6F9"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 154.032H63.144V156.512H65.624V154.032Z",
    fill: "#F2F6F9"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 158.192H63.144V160.672H65.624V158.192Z",
    fill: "#F2F6F9"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 162.344H63.144V164.824H65.624V162.344Z",
    fill: "#F2F6F9"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 166.504H63.144V168.984H65.624V166.504Z",
    fill: "#F2F6F9"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 170.656H63.144V173.136H65.624V170.656Z",
    fill: "#F2F6F9"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 174.816H63.144V177.296H65.624V174.816Z",
    fill: "#F2F6F9"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 178.968H63.144V181.448H65.624V178.968Z",
    fill: "#F2F6F9"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 183.128H63.144V185.608H65.624V183.128Z",
    fill: "#F2F6F9"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 187.28H63.144V189.76H65.624V187.28Z",
    fill: "#F2F6F9"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 191.44H63.144V193.92H65.624V191.44Z",
    fill: "#F2F6F9"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 195.6H63.144V198.08H65.624V195.6Z",
    fill: "#F2F6F9"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 199.752H63.144V202.232H65.624V199.752Z",
    fill: "#F2F6F9"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 203.912H63.144V206.392H65.624V203.912Z",
    fill: "#F2F6F9"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 208.064H63.144V210.544H65.624V208.064Z",
    fill: "#F2F6F9"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 212.224H63.144V214.704H65.624V212.224Z",
    fill: "#F2F6F9"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 216.376H63.144V218.856H65.624V216.376Z",
    fill: "#F2F6F9"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 220.536H63.144V223.016H65.624V220.536Z",
    fill: "#F2F6F9"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M65.624 224.688H63.144V227.168H65.624V224.688Z",
    fill: "#F2F6F9"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 154.032H67.0879V156.512H69.5679V154.032Z",
    fill: "#F2F6F9"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 158.192H67.0879V160.672H69.5679V158.192Z",
    fill: "#F2F6F9"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 162.344H67.0879V164.824H69.5679V162.344Z",
    fill: "#F2F6F9"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 166.504H67.0879V168.984H69.5679V166.504Z",
    fill: "#F2F6F9"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 170.656H67.0879V173.136H69.5679V170.656Z",
    fill: "#F2F6F9"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 174.816H67.0879V177.296H69.5679V174.816Z",
    fill: "#F2F6F9"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 178.968H67.0879V181.448H69.5679V178.968Z",
    fill: "#F2F6F9"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 183.128H67.0879V185.608H69.5679V183.128Z",
    fill: "#F2F6F9"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 187.28H67.0879V189.76H69.5679V187.28Z",
    fill: "#F2F6F9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 191.44H67.0879V193.92H69.5679V191.44Z",
    fill: "#F2F6F9"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 195.6H67.0879V198.08H69.5679V195.6Z",
    fill: "#F2F6F9"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 199.752H67.0879V202.232H69.5679V199.752Z",
    fill: "#F2F6F9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 203.912H67.0879V206.392H69.5679V203.912Z",
    fill: "#F2F6F9"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 208.064H67.0879V210.544H69.5679V208.064Z",
    fill: "#F2F6F9"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 212.224H67.0879V214.704H69.5679V212.224Z",
    fill: "#F2F6F9"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 216.376H67.0879V218.856H69.5679V216.376Z",
    fill: "#F2F6F9"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 220.536H67.0879V223.016H69.5679V220.536Z",
    fill: "#F2F6F9"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5679 224.688H67.0879V227.168H69.5679V224.688Z",
    fill: "#F2F6F9"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 184.368H44.48V186.848H46.9599V184.368Z",
    fill: "#F2F6F9"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 188.52H44.48V191H46.9599V188.52Z",
    fill: "#F2F6F9"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 192.68H44.48V195.16H46.9599V192.68Z",
    fill: "#F2F6F9"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 196.832H44.48V199.312H46.9599V196.832Z",
    fill: "#F2F6F9"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 200.992H44.48V203.472H46.9599V200.992Z",
    fill: "#F2F6F9"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 205.144H44.48V207.624H46.9599V205.144Z",
    fill: "#F2F6F9"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 209.304H44.48V211.784H46.9599V209.304Z",
    fill: "#F2F6F9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 213.464H44.48V215.944H46.9599V213.464Z",
    fill: "#F2F6F9"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 217.616H44.48V220.096H46.9599V217.616Z",
    fill: "#F2F6F9"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 221.776H44.48V224.256H46.9599V221.776Z",
    fill: "#F2F6F9"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 225.928H44.48V228.408H46.9599V225.928Z",
    fill: "#F2F6F9"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 230.088H44.48V232.568H46.9599V230.088Z",
    fill: "#F2F6F9"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9599 234.24H44.48V236.72H46.9599V234.24Z",
    fill: "#F2F6F9"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 184.368H48.416V186.848H50.896V184.368Z",
    fill: "#F2F6F9"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 188.52H48.416V191H50.896V188.52Z",
    fill: "#F2F6F9"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 192.68H48.416V195.16H50.896V192.68Z",
    fill: "#F2F6F9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 196.832H48.416V199.312H50.896V196.832Z",
    fill: "#F2F6F9"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 200.992H48.416V203.472H50.896V200.992Z",
    fill: "#F2F6F9"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 205.144H48.416V207.624H50.896V205.144Z",
    fill: "#F2F6F9"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 209.304H48.416V211.784H50.896V209.304Z",
    fill: "#F2F6F9"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 213.464H48.416V215.944H50.896V213.464Z",
    fill: "#F2F6F9"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 217.616H48.416V220.096H50.896V217.616Z",
    fill: "#F2F6F9"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 221.776H48.416V224.256H50.896V221.776Z",
    fill: "#F2F6F9"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 225.928H48.416V228.408H50.896V225.928Z",
    fill: "#F2F6F9"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 230.088H48.416V232.568H50.896V230.088Z",
    fill: "#F2F6F9"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M50.896 234.24H48.416V236.72H50.896V234.24Z",
    fill: "#F2F6F9"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 184.368H52.3599V186.848H54.8399V184.368Z",
    fill: "#F2F6F9"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 188.52H52.3599V191H54.8399V188.52Z",
    fill: "#F2F6F9"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 192.68H52.3599V195.16H54.8399V192.68Z",
    fill: "#F2F6F9"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 196.832H52.3599V199.312H54.8399V196.832Z",
    fill: "#F2F6F9"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 200.992H52.3599V203.472H54.8399V200.992Z",
    fill: "#F2F6F9"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 205.144H52.3599V207.624H54.8399V205.144Z",
    fill: "#F2F6F9"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 209.304H52.3599V211.784H54.8399V209.304Z",
    fill: "#F2F6F9"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 213.464H52.3599V215.944H54.8399V213.464Z",
    fill: "#F2F6F9"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 217.616H52.3599V220.096H54.8399V217.616Z",
    fill: "#F2F6F9"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 221.776H52.3599V224.256H54.8399V221.776Z",
    fill: "#F2F6F9"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 225.928H52.3599V228.408H54.8399V225.928Z",
    fill: "#F2F6F9"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 230.088H52.3599V232.568H54.8399V230.088Z",
    fill: "#F2F6F9"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 234.24H52.3599V236.72H54.8399V234.24Z",
    fill: "#F2F6F9"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8399 238.4H52.3599V240.88H54.8399V238.4Z",
    fill: "#F2F6F9"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 185.608H74.2319V188.088H76.7119V185.608Z",
    fill: "#F2F6F9"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 189.76H74.2319V192.24H76.7119V189.76Z",
    fill: "#F2F6F9"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 193.92H74.2319V196.4H76.7119V193.92Z",
    fill: "#F2F6F9"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 198.072H74.2319V200.552H76.7119V198.072Z",
    fill: "#F2F6F9"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 202.232H74.2319V204.712H76.7119V202.232Z",
    fill: "#F2F6F9"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 206.384H74.2319V208.864H76.7119V206.384Z",
    fill: "#F2F6F9"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 210.544H74.2319V213.024H76.7119V210.544Z",
    fill: "#F2F6F9"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 214.696H74.2319V217.176H76.7119V214.696Z",
    fill: "#F2F6F9"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 218.856H74.2319V221.336H76.7119V218.856Z",
    fill: "#F2F6F9"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 223.008H74.2319V225.488H76.7119V223.008Z",
    fill: "#F2F6F9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7119 235.48H74.2319V237.96H76.7119V235.48Z",
    fill: "#F2F6F9"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 185.608H78.168V188.088H80.648V185.608Z",
    fill: "#F2F6F9"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 189.76H78.168V192.24H80.648V189.76Z",
    fill: "#F2F6F9"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 193.92H78.168V196.4H80.648V193.92Z",
    fill: "#F2F6F9"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 198.072H78.168V200.552H80.648V198.072Z",
    fill: "#F2F6F9"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 202.232H78.168V204.712H80.648V202.232Z",
    fill: "#F2F6F9"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 206.384H78.168V208.864H80.648V206.384Z",
    fill: "#F2F6F9"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 210.544H78.168V213.024H80.648V210.544Z",
    fill: "#F2F6F9"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 214.696H78.168V217.176H80.648V214.696Z",
    fill: "#F2F6F9"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 218.856H78.168V221.336H80.648V218.856Z",
    fill: "#F2F6F9"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 231.32H78.168V233.8H80.648V231.32Z",
    fill: "#F2F6F9"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M80.648 235.48H78.168V237.96H80.648V235.48Z",
    fill: "#F2F6F9"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 185.608H82.104V188.088H84.584V185.608Z",
    fill: "#F2F6F9"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 189.76H82.104V192.24H84.584V189.76Z",
    fill: "#F2F6F9"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 193.92H82.104V196.4H84.584V193.92Z",
    fill: "#F2F6F9"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 198.072H82.104V200.552H84.584V198.072Z",
    fill: "#F2F6F9"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 202.232H82.104V204.712H84.584V202.232Z",
    fill: "#F2F6F9"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 206.384H82.104V208.864H84.584V206.384Z",
    fill: "#F2F6F9"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 210.544H82.104V213.024H84.584V210.544Z",
    fill: "#F2F6F9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 214.696H82.104V217.176H84.584V214.696Z",
    fill: "#F2F6F9"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 227.168H82.104V229.648H84.584V227.168Z",
    fill: "#F2F6F9"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 231.32H82.104V233.8H84.584V231.32Z",
    fill: "#F2F6F9"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M84.584 235.48H82.104V237.96H84.584V235.48Z",
    fill: "#F2F6F9"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 122.464H118.712V124.944H121.192V122.464Z",
    fill: "#F2F6F9"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 126.616H118.712V129.096H121.192V126.616Z",
    fill: "#F2F6F9"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 130.776H118.712V133.256H121.192V130.776Z",
    fill: "#F2F6F9"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 134.928H118.712V137.408H121.192V134.928Z",
    fill: "#F2F6F9"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 139.088H118.712V141.568H121.192V139.088Z",
    fill: "#F2F6F9"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 143.24H118.712V145.72H121.192V143.24Z",
    fill: "#F2F6F9"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 147.4H118.712V149.88H121.192V147.4Z",
    fill: "#F2F6F9"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 151.56H118.712V154.04H121.192V151.56Z",
    fill: "#F2F6F9"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 155.712H118.712V158.192H121.192V155.712Z",
    fill: "#F2F6F9"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 159.872H118.712V162.352H121.192V159.872Z",
    fill: "#F2F6F9"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 164.024H118.712V166.504H121.192V164.024Z",
    fill: "#F2F6F9"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 168.184H118.712V170.664H121.192V168.184Z",
    fill: "#F2F6F9"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 172.336H118.712V174.816H121.192V172.336Z",
    fill: "#F2F6F9"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 176.496H118.712V178.976H121.192V176.496Z",
    fill: "#F2F6F9"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 180.648H118.712V183.128H121.192V180.648Z",
    fill: "#F2F6F9"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 184.808H118.712V187.288H121.192V184.808Z",
    fill: "#F2F6F9"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 188.96H118.712V191.44H121.192V188.96Z",
    fill: "#F2F6F9"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 197.272H118.712V199.752H121.192V197.272Z",
    fill: "#F2F6F9"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 201.432H118.712V203.912H121.192V201.432Z",
    fill: "#F2F6F9"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 205.584H118.712V208.064H121.192V205.584Z",
    fill: "#F2F6F9"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 209.744H118.712V212.224H121.192V209.744Z",
    fill: "#F2F6F9"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M121.192 213.896H118.712V216.376H121.192V213.896Z",
    fill: "#F2F6F9"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 122.464H122.648V124.944H125.128V122.464Z",
    fill: "#F2F6F9"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 126.616H122.648V129.096H125.128V126.616Z",
    fill: "#F2F6F9"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 130.776H122.648V133.256H125.128V130.776Z",
    fill: "#F2F6F9"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 134.928H122.648V137.408H125.128V134.928Z",
    fill: "#F2F6F9"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 139.088H122.648V141.568H125.128V139.088Z",
    fill: "#F2F6F9"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 143.24H122.648V145.72H125.128V143.24Z",
    fill: "#F2F6F9"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 147.4H122.648V149.88H125.128V147.4Z",
    fill: "#F2F6F9"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 151.56H122.648V154.04H125.128V151.56Z",
    fill: "#F2F6F9"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 155.712H122.648V158.192H125.128V155.712Z",
    fill: "#F2F6F9"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 159.872H122.648V162.352H125.128V159.872Z",
    fill: "#F2F6F9"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 164.024H122.648V166.504H125.128V164.024Z",
    fill: "#F2F6F9"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 168.184H122.648V170.664H125.128V168.184Z",
    fill: "#F2F6F9"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 172.336H122.648V174.816H125.128V172.336Z",
    fill: "#F2F6F9"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 176.496H122.648V178.976H125.128V176.496Z",
    fill: "#F2F6F9"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 180.648H122.648V183.128H125.128V180.648Z",
    fill: "#F2F6F9"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 184.808H122.648V187.288H125.128V184.808Z",
    fill: "#F2F6F9"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 209.744H122.648V212.224H125.128V209.744Z",
    fill: "#F2F6F9"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M125.128 213.896H122.648V216.376H125.128V213.896Z",
    fill: "#F2F6F9"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 122.464H126.584V124.944H129.064V122.464Z",
    fill: "#F2F6F9"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 126.616H126.584V129.096H129.064V126.616Z",
    fill: "#F2F6F9"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 130.776H126.584V133.256H129.064V130.776Z",
    fill: "#F2F6F9"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 134.928H126.584V137.408H129.064V134.928Z",
    fill: "#F2F6F9"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 139.088H126.584V141.568H129.064V139.088Z",
    fill: "#F2F6F9"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 143.24H126.584V145.72H129.064V143.24Z",
    fill: "#F2F6F9"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 147.4H126.584V149.88H129.064V147.4Z",
    fill: "#F2F6F9"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 151.56H126.584V154.04H129.064V151.56Z",
    fill: "#F2F6F9"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 155.712H126.584V158.192H129.064V155.712Z",
    fill: "#F2F6F9"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 159.872H126.584V162.352H129.064V159.872Z",
    fill: "#F2F6F9"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 164.024H126.584V166.504H129.064V164.024Z",
    fill: "#F2F6F9"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 168.184H126.584V170.664H129.064V168.184Z",
    fill: "#F2F6F9"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 172.336H126.584V174.816H129.064V172.336Z",
    fill: "#F2F6F9"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 176.496H126.584V178.976H129.064V176.496Z",
    fill: "#F2F6F9"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 180.648H126.584V183.128H129.064V180.648Z",
    fill: "#F2F6F9"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 184.808H126.584V187.288H129.064V184.808Z",
    fill: "#F2F6F9"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 193.12H126.584V195.6H129.064V193.12Z",
    fill: "#F2F6F9"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 197.272H126.584V199.752H129.064V197.272Z",
    fill: "#F2F6F9"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 201.432H126.584V203.912H129.064V201.432Z",
    fill: "#F2F6F9"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 205.584H126.584V208.064H129.064V205.584Z",
    fill: "#F2F6F9"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M129.064 213.896H126.584V216.376H129.064V213.896Z",
    fill: "#F2F6F9"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 174.816H104.416V177.296H106.896V174.816Z",
    fill: "#F2F6F9"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 178.968H104.416V181.448H106.896V178.968Z",
    fill: "#F2F6F9"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 183.128H104.416V185.608H106.896V183.128Z",
    fill: "#F2F6F9"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 187.28H104.416V189.76H106.896V187.28Z",
    fill: "#F2F6F9"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 191.44H104.416V193.92H106.896V191.44Z",
    fill: "#F2F6F9"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 195.6H104.416V198.08H106.896V195.6Z",
    fill: "#F2F6F9"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 199.752H104.416V202.232H106.896V199.752Z",
    fill: "#F2F6F9"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 208.064H104.416V210.544H106.896V208.064Z",
    fill: "#F2F6F9"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 212.224H104.416V214.704H106.896V212.224Z",
    fill: "#F2F6F9"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 216.376H104.416V218.856H106.896V216.376Z",
    fill: "#F2F6F9"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 220.536H104.416V223.016H106.896V220.536Z",
    fill: "#F2F6F9"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 224.688H104.416V227.168H106.896V224.688Z",
    fill: "#F2F6F9"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 228.848H104.416V231.328H106.896V228.848Z",
    fill: "#F2F6F9"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 233H104.416V235.48H106.896V233Z",
    fill: "#F2F6F9"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M106.896 237.16H104.416V239.64H106.896V237.16Z",
    fill: "#F2F6F9"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 174.816H108.352V177.296H110.832V174.816Z",
    fill: "#F2F6F9"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 178.968H108.352V181.448H110.832V178.968Z",
    fill: "#F2F6F9"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 183.128H108.352V185.608H110.832V183.128Z",
    fill: "#F2F6F9"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 187.28H108.352V189.76H110.832V187.28Z",
    fill: "#F2F6F9"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 191.44H108.352V193.92H110.832V191.44Z",
    fill: "#F2F6F9"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 195.6H108.352V198.08H110.832V195.6Z",
    fill: "#F2F6F9"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 208.064H108.352V210.544H110.832V208.064Z",
    fill: "#F2F6F9"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 212.224H108.352V214.704H110.832V212.224Z",
    fill: "#F2F6F9"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 216.376H108.352V218.856H110.832V216.376Z",
    fill: "#F2F6F9"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 220.536H108.352V223.016H110.832V220.536Z",
    fill: "#F2F6F9"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 224.688H108.352V227.168H110.832V224.688Z",
    fill: "#F2F6F9"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 228.848H108.352V231.328H110.832V228.848Z",
    fill: "#F2F6F9"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 233H108.352V235.48H110.832V233Z",
    fill: "#F2F6F9"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M110.832 237.16H108.352V239.64H110.832V237.16Z",
    fill: "#F2F6F9"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 174.816H112.288V177.296H114.768V174.816Z",
    fill: "#F2F6F9"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 178.968H112.288V181.448H114.768V178.968Z",
    fill: "#F2F6F9"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 183.128H112.288V185.608H114.768V183.128Z",
    fill: "#F2F6F9"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 187.28H112.288V189.76H114.768V187.28Z",
    fill: "#F2F6F9"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 191.44H112.288V193.92H114.768V191.44Z",
    fill: "#F2F6F9"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 195.6H112.288V198.08H114.768V195.6Z",
    fill: "#F2F6F9"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 203.912H112.288V206.392H114.768V203.912Z",
    fill: "#F2F6F9"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 208.064H112.288V210.544H114.768V208.064Z",
    fill: "#F2F6F9"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 212.224H112.288V214.704H114.768V212.224Z",
    fill: "#F2F6F9"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 216.376H112.288V218.856H114.768V216.376Z",
    fill: "#F2F6F9"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 220.536H112.288V223.016H114.768V220.536Z",
    fill: "#F2F6F9"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 224.688H112.288V227.168H114.768V224.688Z",
    fill: "#F2F6F9"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 228.848H112.288V231.328H114.768V228.848Z",
    fill: "#F2F6F9"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 233H112.288V235.48H114.768V233Z",
    fill: "#F2F6F9"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M114.768 237.16H112.288V239.64H114.768V237.16Z",
    fill: "#F2F6F9"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 151.56H195.272V154.04H197.752V151.56Z",
    fill: "#F2F6F9"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 155.712H195.272V158.192H197.752V155.712Z",
    fill: "#F2F6F9"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 159.872H195.272V162.352H197.752V159.872Z",
    fill: "#F2F6F9"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 164.024H195.272V166.504H197.752V164.024Z",
    fill: "#F2F6F9"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 168.184H195.272V170.664H197.752V168.184Z",
    fill: "#F2F6F9"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 172.336H195.272V174.816H197.752V172.336Z",
    fill: "#F2F6F9"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 176.496H195.272V178.976H197.752V176.496Z",
    fill: "#F2F6F9"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 180.648H195.272V183.128H197.752V180.648Z",
    fill: "#F2F6F9"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 184.808H195.272V187.288H197.752V184.808Z",
    fill: "#F2F6F9"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 188.96H195.272V191.44H197.752V188.96Z",
    fill: "#F2F6F9"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 193.12H195.272V195.6H197.752V193.12Z",
    fill: "#F2F6F9"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 197.272H195.272V199.752H197.752V197.272Z",
    fill: "#F2F6F9"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 201.432H195.272V203.912H197.752V201.432Z",
    fill: "#F2F6F9"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 209.744H195.272V212.224H197.752V209.744Z",
    fill: "#F2F6F9"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 213.896H195.272V216.376H197.752V213.896Z",
    fill: "#F2F6F9"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 218.056H195.272V220.536H197.752V218.056Z",
    fill: "#F2F6F9"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 222.208H195.272V224.688H197.752V222.208Z",
    fill: "#F2F6F9"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 230.52H195.272V233H197.752V230.52Z",
    fill: "#F2F6F9"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 234.68H195.272V237.16H197.752V234.68Z",
    fill: "#F2F6F9"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M197.752 238.832H195.272V241.312H197.752V238.832Z",
    fill: "#F2F6F9"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 151.56H199.208V154.04H201.688V151.56Z",
    fill: "#F2F6F9"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 155.712H199.208V158.192H201.688V155.712Z",
    fill: "#F2F6F9"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 159.872H199.208V162.352H201.688V159.872Z",
    fill: "#F2F6F9"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 164.024H199.208V166.504H201.688V164.024Z",
    fill: "#F2F6F9"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 168.184H199.208V170.664H201.688V168.184Z",
    fill: "#F2F6F9"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 172.336H199.208V174.816H201.688V172.336Z",
    fill: "#F2F6F9"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 176.496H199.208V178.976H201.688V176.496Z",
    fill: "#F2F6F9"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 180.648H199.208V183.128H201.688V180.648Z",
    fill: "#F2F6F9"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 184.808H199.208V187.288H201.688V184.808Z",
    fill: "#F2F6F9"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 188.96H199.208V191.44H201.688V188.96Z",
    fill: "#F2F6F9"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 193.12H199.208V195.6H201.688V193.12Z",
    fill: "#F2F6F9"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 197.272H199.208V199.752H201.688V197.272Z",
    fill: "#F2F6F9"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 201.432H199.208V203.912H201.688V201.432Z",
    fill: "#F2F6F9"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 213.896H199.208V216.376H201.688V213.896Z",
    fill: "#F2F6F9"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 218.056H199.208V220.536H201.688V218.056Z",
    fill: "#F2F6F9"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 226.368H199.208V228.848H201.688V226.368Z",
    fill: "#F2F6F9"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 230.52H199.208V233H201.688V230.52Z",
    fill: "#F2F6F9"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 234.68H199.208V237.16H201.688V234.68Z",
    fill: "#F2F6F9"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M201.688 238.832H199.208V241.312H201.688V238.832Z",
    fill: "#F2F6F9"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 151.56H203.144V154.04H205.624V151.56Z",
    fill: "#F2F6F9"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 155.712H203.144V158.192H205.624V155.712Z",
    fill: "#F2F6F9"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 159.872H203.144V162.352H205.624V159.872Z",
    fill: "#F2F6F9"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 164.024H203.144V166.504H205.624V164.024Z",
    fill: "#F2F6F9"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 168.184H203.144V170.664H205.624V168.184Z",
    fill: "#F2F6F9"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 172.336H203.144V174.816H205.624V172.336Z",
    fill: "#F2F6F9"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 176.496H203.144V178.976H205.624V176.496Z",
    fill: "#F2F6F9"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 180.648H203.144V183.128H205.624V180.648Z",
    fill: "#F2F6F9"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 184.808H203.144V187.288H205.624V184.808Z",
    fill: "#F2F6F9"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 188.96H203.144V191.44H205.624V188.96Z",
    fill: "#F2F6F9"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 193.12H203.144V195.6H205.624V193.12Z",
    fill: "#F2F6F9"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 197.272H203.144V199.752H205.624V197.272Z",
    fill: "#F2F6F9"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 201.432H203.144V203.912H205.624V201.432Z",
    fill: "#F2F6F9"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 205.584H203.144V208.064H205.624V205.584Z",
    fill: "#F2F6F9"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 213.896H203.144V216.376H205.624V213.896Z",
    fill: "#F2F6F9"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 222.208H203.144V224.688H205.624V222.208Z",
    fill: "#F2F6F9"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 226.368H203.144V228.848H205.624V226.368Z",
    fill: "#F2F6F9"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 230.52H203.144V233H205.624V230.52Z",
    fill: "#F2F6F9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 234.68H203.144V237.16H205.624V234.68Z",
    fill: "#F2F6F9"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M205.624 238.832H203.144V241.312H205.624V238.832Z",
    fill: "#F2F6F9"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 175.256H179.224V177.736H181.704V175.256Z",
    fill: "#F2F6F9"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 179.408H179.224V181.888H181.704V179.408Z",
    fill: "#F2F6F9"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 183.568H179.224V186.048H181.704V183.568Z",
    fill: "#F2F6F9"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 187.72H179.224V190.2H181.704V187.72Z",
    fill: "#F2F6F9"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 191.88H179.224V194.36H181.704V191.88Z",
    fill: "#F2F6F9"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 196.032H179.224V198.512H181.704V196.032Z",
    fill: "#F2F6F9"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 208.504H179.224V210.984H181.704V208.504Z",
    fill: "#F2F6F9"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 212.656H179.224V215.136H181.704V212.656Z",
    fill: "#F2F6F9"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 216.816H179.224V219.296H181.704V216.816Z",
    fill: "#F2F6F9"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 220.968H179.224V223.448H181.704V220.968Z",
    fill: "#F2F6F9"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 225.128H179.224V227.608H181.704V225.128Z",
    fill: "#F2F6F9"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 229.28H179.224V231.76H181.704V229.28Z",
    fill: "#F2F6F9"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 233.44H179.224V235.92H181.704V233.44Z",
    fill: "#F2F6F9"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 175.256H183.168V177.736H185.648V175.256Z",
    fill: "#F2F6F9"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 179.408H183.168V181.888H185.648V179.408Z",
    fill: "#F2F6F9"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 183.568H183.168V186.048H185.648V183.568Z",
    fill: "#F2F6F9"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 187.72H183.168V190.2H185.648V187.72Z",
    fill: "#F2F6F9"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 191.88H183.168V194.36H185.648V191.88Z",
    fill: "#F2F6F9"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 196.032H183.168V198.512H185.648V196.032Z",
    fill: "#F2F6F9"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 208.504H183.168V210.984H185.648V208.504Z",
    fill: "#F2F6F9"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 212.656H183.168V215.136H185.648V212.656Z",
    fill: "#F2F6F9"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 216.816H183.168V219.296H185.648V216.816Z",
    fill: "#F2F6F9"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 220.968H183.168V223.448H185.648V220.968Z",
    fill: "#F2F6F9"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 225.128H183.168V227.608H185.648V225.128Z",
    fill: "#F2F6F9"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 229.28H183.168V231.76H185.648V229.28Z",
    fill: "#F2F6F9"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 237.592H183.168V240.072H185.648V237.592Z",
    fill: "#F2F6F9"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 156.952H313.968V159.432H316.448V156.952Z",
    fill: "#F2F6F9"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 161.104H313.968V163.584H316.448V161.104Z",
    fill: "#F2F6F9"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 165.264H313.968V167.744H316.448V165.264Z",
    fill: "#F2F6F9"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 169.424H313.968V171.904H316.448V169.424Z",
    fill: "#F2F6F9"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 173.576H313.968V176.056H316.448V173.576Z",
    fill: "#F2F6F9"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 177.736H313.968V180.216H316.448V177.736Z",
    fill: "#F2F6F9"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 181.888H313.968V184.368H316.448V181.888Z",
    fill: "#F2F6F9"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 186.048H313.968V188.528H316.448V186.048Z",
    fill: "#F2F6F9"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 190.2H313.968V192.68H316.448V190.2Z",
    fill: "#F2F6F9"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 194.36H313.968V196.84H316.448V194.36Z",
    fill: "#F2F6F9"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 198.512H313.968V200.992H316.448V198.512Z",
    fill: "#F2F6F9"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 206.824H313.968V209.304H316.448V206.824Z",
    fill: "#F2F6F9"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 210.984H313.968V213.464H316.448V210.984Z",
    fill: "#F2F6F9"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 215.136H313.968V217.616H316.448V215.136Z",
    fill: "#F2F6F9"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 219.296H313.968V221.776H316.448V219.296Z",
    fill: "#F2F6F9"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 223.448H313.968V225.928H316.448V223.448Z",
    fill: "#F2F6F9"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 227.608H313.968V230.088H316.448V227.608Z",
    fill: "#F2F6F9"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 231.76H313.968V234.24H316.448V231.76Z",
    fill: "#F2F6F9"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M316.448 235.92H313.968V238.4H316.448V235.92Z",
    fill: "#F2F6F9"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 156.952H317.912V159.432H320.392V156.952Z",
    fill: "#F2F6F9"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 161.104H317.912V163.584H320.392V161.104Z",
    fill: "#F2F6F9"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 165.264H317.912V167.744H320.392V165.264Z",
    fill: "#F2F6F9"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 169.424H317.912V171.904H320.392V169.424Z",
    fill: "#F2F6F9"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 173.576H317.912V176.056H320.392V173.576Z",
    fill: "#F2F6F9"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 177.736H317.912V180.216H320.392V177.736Z",
    fill: "#F2F6F9"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 181.888H317.912V184.368H320.392V181.888Z",
    fill: "#F2F6F9"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 186.048H317.912V188.528H320.392V186.048Z",
    fill: "#F2F6F9"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 190.2H317.912V192.68H320.392V190.2Z",
    fill: "#F2F6F9"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 194.36H317.912V196.84H320.392V194.36Z",
    fill: "#F2F6F9"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 198.512H317.912V200.992H320.392V198.512Z",
    fill: "#F2F6F9"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 202.672H317.912V205.152H320.392V202.672Z",
    fill: "#F2F6F9"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 206.824H317.912V209.304H320.392V206.824Z",
    fill: "#F2F6F9"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 210.984H317.912V213.464H320.392V210.984Z",
    fill: "#F2F6F9"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 215.136H317.912V217.616H320.392V215.136Z",
    fill: "#F2F6F9"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 219.296H317.912V221.776H320.392V219.296Z",
    fill: "#F2F6F9"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 223.448H317.912V225.928H320.392V223.448Z",
    fill: "#F2F6F9"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 227.608H317.912V230.088H320.392V227.608Z",
    fill: "#F2F6F9"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 231.76H317.912V234.24H320.392V231.76Z",
    fill: "#F2F6F9"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M320.392 235.92H317.912V238.4H320.392V235.92Z",
    fill: "#F2F6F9"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 173.136H294.576V175.616H297.056V173.136Z",
    fill: "#F2F6F9"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 177.296H294.576V179.776H297.056V177.296Z",
    fill: "#F2F6F9"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 181.448H294.576V183.928H297.056V181.448Z",
    fill: "#F2F6F9"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 185.608H294.576V188.088H297.056V185.608Z",
    fill: "#F2F6F9"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 189.76H294.576V192.24H297.056V189.76Z",
    fill: "#F2F6F9"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 193.92H294.576V196.4H297.056V193.92Z",
    fill: "#F2F6F9"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 198.072H294.576V200.552H297.056V198.072Z",
    fill: "#F2F6F9"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 202.232H294.576V204.712H297.056V202.232Z",
    fill: "#F2F6F9"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 206.384H294.576V208.864H297.056V206.384Z",
    fill: "#F2F6F9"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M297.056 210.544H294.576V213.024H297.056V210.544Z",
    fill: "#F2F6F9"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 173.136H298.512V175.616H300.992V173.136Z",
    fill: "#F2F6F9"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 177.296H298.512V179.776H300.992V177.296Z",
    fill: "#F2F6F9"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 181.448H298.512V183.928H300.992V181.448Z",
    fill: "#F2F6F9"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 185.608H298.512V188.088H300.992V185.608Z",
    fill: "#F2F6F9"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 189.76H298.512V192.24H300.992V189.76Z",
    fill: "#F2F6F9"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 193.92H298.512V196.4H300.992V193.92Z",
    fill: "#F2F6F9"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 198.072H298.512V200.552H300.992V198.072Z",
    fill: "#F2F6F9"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 202.232H298.512V204.712H300.992V202.232Z",
    fill: "#F2F6F9"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 206.384H298.512V208.864H300.992V206.384Z",
    fill: "#F2F6F9"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M200 286.088C285.666 286.088 355.112 282.033 355.112 277.032C355.112 272.031 285.666 267.976 200 267.976C114.334 267.976 44.8879 272.031 44.8879 277.032C44.8879 282.033 114.334 286.088 200 286.088Z",
    fill: "#141E30",
    fillOpacity: 0.05
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M337.728 271.184L326.656 216.04H322.68L311.336 271.184L303.2 276.16V277.64H345.6V276.16L337.728 271.184Z",
    fill: "#5E7CE2"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M345.864 276.16H303.464V278.016H345.864V276.16Z",
    fill: "#141E30"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M326.656 216.36H322.68L311.472 271.344H337.864L326.656 216.36Z",
    fill: "#141E30"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M335.432 259.24H313.976L317.84 240.04H331.528L335.36 258.872L335.432 259.24Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M226.536 82.2001L219.464 84.8401C218.936 84.4401 221.6 60.44 221.6 60.44L217.312 59.8C217.312 59.8 210.064 84.7361 212.512 89.7681C215.712 96.3041 229.84 89.7681 229.84 89.7681L226.536 82.2001Z",
    fill: "#FBCFBD"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M355.983 96.7789L359.275 82.4645L170.412 39.0355L167.12 53.35L355.983 96.7789Z",
    fill: "#5E7CE2"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M355.983 96.7789L359.275 82.4645L170.412 39.0355L167.12 53.35L355.983 96.7789Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.374 90.7678L357.899 88.4834L169.036 45.0545L168.511 47.3388L357.374 90.7678Z",
    fill: "#141E30"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 47.688C175.549 46.1668 175.489 44.5803 175.027 43.0896C174.565 41.5989 173.716 40.257 172.568 39.2L172.248 38.904L170.648 38.528C170.574 38.5102 170.497 38.5073 170.422 38.5195C170.347 38.5316 170.274 38.5585 170.21 38.5987C170.145 38.6389 170.089 38.6915 170.045 38.7535C170 38.8155 169.969 38.8857 169.952 38.96L166.672 53.264C166.654 53.3381 166.651 53.415 166.663 53.4902C166.675 53.5654 166.702 53.6375 166.743 53.7022C166.783 53.7669 166.835 53.823 166.897 53.8673C166.959 53.9115 167.03 53.9431 167.104 53.96L168.704 54.336L169.128 54.208C170.625 53.7525 171.975 52.9096 173.041 51.7646C174.107 50.6197 174.852 49.2134 175.2 47.688Z",
    fill: "#5E7CE2"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.2 47.688C175.549 46.1668 175.489 44.5803 175.027 43.0896C174.565 41.5989 173.716 40.257 172.568 39.2L172.248 38.904L170.648 38.528C170.574 38.5102 170.497 38.5073 170.422 38.5195C170.347 38.5316 170.274 38.5585 170.21 38.5987C170.145 38.6389 170.089 38.6915 170.045 38.7535C170 38.8155 169.969 38.8857 169.952 38.96L166.672 53.264C166.654 53.3381 166.651 53.415 166.663 53.4902C166.675 53.5654 166.702 53.6375 166.743 53.7022C166.783 53.7669 166.835 53.823 166.897 53.8673C166.959 53.9115 167.03 53.9431 167.104 53.96L168.704 54.336L169.128 54.208C170.625 53.7525 171.975 52.9096 173.041 51.7646C174.107 50.6197 174.852 49.2134 175.2 47.688Z",
    fill: "#141E30"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M208.64 59.504L218.032 18.632L214.576 17.832L204.664 60.952C204.641 61.0487 204.638 61.1488 204.655 61.2467C204.671 61.3446 204.707 61.4383 204.76 61.5223C204.812 61.6063 204.881 61.6791 204.962 61.7364C205.043 61.7936 205.135 61.8343 205.232 61.856C205.336 61.8803 205.444 61.8822 205.549 61.8615C205.654 61.8409 205.753 61.7981 205.84 61.736L208.336 59.952C208.486 59.8425 208.594 59.6841 208.64 59.504Z",
    fill: "#5E7CE2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M245.76 68.04L255.2 27.2L251.736 26.4L241.832 69.512C241.798 69.7051 241.837 69.9039 241.94 70.0705C242.043 70.2371 242.204 70.3601 242.392 70.416C242.496 70.4374 242.604 70.4379 242.708 70.4173C242.812 70.3966 242.912 70.3554 243 70.296L245.504 68.504C245.645 68.387 245.736 68.2213 245.76 68.04Z",
    fill: "#5E7CE2"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M282.888 76.568L292.28 35.704L288.824 34.904L278.912 78.016C278.876 78.2114 278.915 78.413 279.02 78.5815C279.125 78.7501 279.289 78.8736 279.48 78.928C279.584 78.9512 279.693 78.9518 279.798 78.9297C279.902 78.9077 280.001 78.8634 280.088 78.8L282.592 77.016C282.739 76.9052 282.844 76.747 282.888 76.568Z",
    fill: "#5E7CE2"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M320 85.104L329.392 44.232L325.936 43.432L316.024 86.544C316.001 86.6407 315.998 86.7408 316.015 86.8387C316.031 86.9366 316.067 87.0303 316.12 87.1143C316.172 87.1983 316.241 87.2711 316.322 87.3284C316.403 87.3856 316.495 87.4263 316.592 87.448C316.696 87.4724 316.804 87.4743 316.909 87.4536C317.014 87.4329 317.113 87.3901 317.2 87.328L319.696 85.544C319.845 85.4366 319.952 85.2812 320 85.104Z",
    fill: "#5E7CE2"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M363.123 65.7313L366.414 51.4169L177.551 7.98797L174.26 22.3024L363.123 65.7313Z",
    fill: "#5E7CE2"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M363.123 65.7313L366.414 51.4169L177.551 7.98797L174.26 22.3024L363.123 65.7313Z",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M364.504 59.7201L365.03 57.4357L176.167 14.0069L175.641 16.2912L364.504 59.7201Z",
    fill: "#141E30"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M171.512 50.968L181.192 8.84001L177.736 8.04001L167.536 52.416C167.513 52.5127 167.51 52.6128 167.527 52.7107C167.543 52.8086 167.579 52.9023 167.632 52.9863C167.684 53.0703 167.753 53.1431 167.834 53.2004C167.915 53.2576 168.007 53.2983 168.104 53.32C168.208 53.3444 168.316 53.3462 168.421 53.3256C168.526 53.3049 168.625 53.2621 168.712 53.2L171.2 51.416C171.353 51.3079 171.464 51.1493 171.512 50.968Z",
    fill: "#5E7CE2"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M182.336 16.64C182.685 15.1151 182.626 13.525 182.164 12.0304C181.701 10.5358 180.853 9.18966 179.704 8.128L179.384 7.832L177.784 7.464C177.71 7.44621 177.633 7.44331 177.558 7.45544C177.483 7.46758 177.411 7.49452 177.346 7.5347C177.281 7.57488 177.225 7.6275 177.181 7.68952C177.136 7.75153 177.105 7.82172 177.088 7.896L173.8 22.192C173.782 22.2666 173.779 22.344 173.791 22.4197C173.803 22.4955 173.83 22.5681 173.87 22.6335C173.91 22.6989 173.963 22.7557 174.025 22.8007C174.087 22.8458 174.157 22.8781 174.232 22.896L175.832 23.264L176.248 23.136C177.745 22.6849 179.096 21.8467 180.165 20.7061C181.234 19.5654 181.983 18.1628 182.336 16.64Z",
    fill: "#5E7CE2"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.336 16.64C182.685 15.1151 182.626 13.525 182.164 12.0304C181.701 10.5358 180.853 9.18966 179.704 8.128L179.384 7.832L177.784 7.464C177.71 7.44621 177.633 7.44331 177.558 7.45544C177.483 7.46758 177.411 7.49452 177.346 7.5347C177.281 7.57488 177.225 7.6275 177.181 7.68952C177.136 7.75153 177.105 7.82172 177.088 7.896L173.8 22.192C173.782 22.2666 173.779 22.344 173.791 22.4197C173.803 22.4955 173.83 22.5681 173.87 22.6335C173.91 22.6989 173.963 22.7557 174.025 22.8007C174.087 22.8458 174.157 22.8781 174.232 22.896L175.832 23.264L176.248 23.136C177.745 22.6849 179.096 21.8467 180.165 20.7061C181.234 19.5654 181.983 18.1628 182.336 16.64Z",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M249.8 88.04C249.377 87.9977 248.951 87.9977 248.528 88.04C245.442 88.3885 242.381 88.9228 239.36 89.64C232.496 91.088 224.96 93.032 224.96 93.032L221.6 83.24C221.6 83.24 243.736 70.4401 247.328 71.4881C247.328 71.4881 253.336 88.576 249.8 88.04Z",
    fill: "#141E30"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M300.6 98C300.6 98 306.536 104.84 305.864 113.64C305.192 122.44 282.848 136.04 282.848 136.04L280 131.64C280 131.64 297.8 116.64 298.2 113.64C298.6 110.64 294.504 104.04 294.504 104.04L300.6 98Z",
    fill: "#FBCFBD"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M280.8 130.104C280.8 130.104 284.44 134.984 284.264 135.608C284.088 136.232 281.144 138.064 281.144 138.064C281.144 138.064 281.64 140.968 281.64 141.504C281.64 142.808 279.312 144.44 278.712 144.04C276.56 142.6 275.776 138.704 275.376 136.92C274.976 135.136 279.752 129.6 280.8 130.104Z",
    fill: "#5E7CE2"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M280.8 130.104C280.8 130.104 284.44 134.984 284.264 135.608C284.088 136.232 281.144 138.064 281.144 138.064C281.144 138.064 281.64 140.968 281.64 141.504C281.64 142.808 279.312 144.44 278.712 144.04C276.56 142.6 275.776 138.704 275.376 136.92C274.976 135.136 279.752 129.6 280.8 130.104Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M248.384 272.056L241.896 272.744L240.68 258.752L247.168 258.064L248.384 272.056Z",
    fill: "#FBCFBD"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M280.768 271.584H274.48L273.96 257.016H280.256L280.768 271.584Z",
    fill: "#FBCFBD"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M273.6 270.856H281.24C281.364 270.859 281.484 270.904 281.581 270.982C281.678 271.06 281.746 271.167 281.776 271.288L283.016 276.888C283.066 277.129 283.019 277.379 282.886 277.586C282.753 277.793 282.544 277.938 282.304 277.992C282.235 278.004 282.165 278.004 282.096 277.992C279.624 277.952 277.824 277.8 274.72 277.8C272.808 277.8 267.04 278 264.4 278C261.76 278 261.416 275.392 262.496 275.152C267.344 274.096 270.992 272.632 272.544 271.24C272.836 270.985 273.212 270.848 273.6 270.856Z",
    fill: "#141E30"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M271.528 272C271.1 272.04 270.672 271.927 270.32 271.68C270.205 271.584 270.116 271.46 270.061 271.32C270.007 271.18 269.988 271.029 270.008 270.88C270.006 270.793 270.029 270.708 270.075 270.634C270.12 270.56 270.186 270.501 270.264 270.464C270.96 270.104 272.992 271.352 273.216 271.496C273.242 271.509 273.263 271.53 273.276 271.556C273.289 271.582 273.293 271.612 273.288 271.64C273.286 271.671 273.273 271.699 273.253 271.722C273.233 271.745 273.206 271.761 273.176 271.768C272.638 271.91 272.085 271.987 271.528 272ZM270.592 270.696C270.526 270.693 270.46 270.707 270.4 270.736C270.36 270.736 270.312 270.792 270.304 270.912C270.29 271.011 270.301 271.112 270.336 271.205C270.371 271.299 270.429 271.382 270.504 271.448C271.21 271.768 272.01 271.808 272.744 271.56C272.089 271.127 271.36 270.821 270.592 270.656V270.696Z",
    fill: "#5E7CE2"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M273.136 271.736H273.064C272.416 271.384 271.16 270 271.288 269.336C271.312 269.226 271.372 269.127 271.459 269.056C271.546 268.985 271.655 268.945 271.768 268.944C271.881 268.929 271.996 268.939 272.105 268.972C272.214 269.005 272.314 269.061 272.4 269.136C273.128 269.728 273.28 271.536 273.288 271.624C273.289 271.651 273.283 271.678 273.27 271.702C273.258 271.726 273.239 271.746 273.216 271.76C273.202 271.762 273.187 271.761 273.173 271.757C273.159 271.753 273.147 271.746 273.136 271.736ZM271.872 269.184H271.8C271.608 269.184 271.592 269.296 271.584 269.336C271.504 269.744 272.304 270.792 272.952 271.28C272.908 270.564 272.649 269.878 272.208 269.312C272.114 269.232 271.995 269.187 271.872 269.184Z",
    fill: "#5E7CE2"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M241.208 270.656H248.848C248.972 270.659 249.092 270.704 249.189 270.782C249.286 270.86 249.354 270.967 249.384 271.088L250.624 276.688C250.674 276.929 250.627 277.179 250.494 277.386C250.361 277.593 250.152 277.738 249.912 277.792C249.843 277.804 249.773 277.804 249.704 277.792C247.232 277.752 245.432 277.6 242.328 277.6C240.416 277.6 234.648 277.8 232.008 277.8C229.368 277.8 229.024 275.192 230.104 274.952C234.952 273.896 238.6 272.432 240.152 271.04C240.444 270.785 240.82 270.648 241.208 270.656Z",
    fill: "#141E30"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M239.128 271.76C238.7 271.8 238.272 271.687 237.92 271.44C237.804 271.344 237.715 271.22 237.661 271.08C237.606 270.94 237.588 270.789 237.608 270.64C237.606 270.553 237.629 270.468 237.674 270.394C237.72 270.32 237.786 270.261 237.864 270.224C238.56 269.864 240.592 271.112 240.816 271.256C240.842 271.269 240.863 271.29 240.876 271.316C240.888 271.342 240.893 271.372 240.888 271.4C240.885 271.431 240.873 271.459 240.853 271.482C240.833 271.505 240.806 271.521 240.776 271.528C240.238 271.67 239.684 271.747 239.128 271.76ZM238.192 270.456C238.126 270.453 238.059 270.467 238 270.496C237.96 270.496 237.912 270.552 237.904 270.672C237.89 270.771 237.901 270.872 237.936 270.965C237.971 271.059 238.029 271.142 238.104 271.208C238.809 271.528 239.61 271.568 240.344 271.32C239.686 270.901 238.956 270.609 238.192 270.456Z",
    fill: "#5E7CE2"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M240.736 271.536H240.664C240.016 271.184 238.76 269.8 238.888 269.136C238.912 269.026 238.972 268.927 239.059 268.856C239.146 268.785 239.255 268.745 239.368 268.744C239.481 268.729 239.596 268.739 239.705 268.772C239.814 268.805 239.914 268.861 240 268.936C240.728 269.528 240.88 271.336 240.888 271.424C240.889 271.451 240.883 271.478 240.87 271.502C240.858 271.526 240.839 271.546 240.816 271.56C240.802 271.562 240.787 271.561 240.773 271.557C240.759 271.553 240.747 271.546 240.736 271.536ZM239.472 268.984H239.4C239.208 268.984 239.192 269.096 239.184 269.136C239.104 269.544 239.904 270.592 240.552 271.08C240.508 270.364 240.249 269.678 239.808 269.112C239.714 269.032 239.595 268.987 239.472 268.984Z",
    fill: "#5E7CE2"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.168 258.064L240.68 258.752L241.312 265.968L247.8 265.28L247.168 258.064Z",
    fill: "#141E30"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M280.256 257.024H273.96L274.232 264.536H280.528L280.256 257.024Z",
    fill: "#141E30"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M277.656 129.24H244.28C241.08 146.568 231.176 207.896 238.304 262.544L249.6 261.136C249.6 261.136 248.552 188.6 258.528 161.776C259.68 176.128 261.04 191.376 262.224 199.528C265.128 219.528 271.344 263.24 271.344 263.24H282.848C282.848 263.24 280.496 221.4 279.408 201.744C278.216 180.408 277.704 133.6 277.656 129.24Z",
    fill: "#5E7CE2"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.528 161.784C256.885 166.485 255.638 171.315 254.8 176.224C253.864 163.424 257.6 149.904 257.6 149.904L258.528 161.784Z",
    fill: "#141E30"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M237.008 265.176L250.992 263.096L250.568 259.216L236.016 261.128L237.008 265.176Z",
    fill: "#5E7CE2"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M237.008 265.176L250.992 263.096L250.568 259.216L236.016 261.128L237.008 265.176Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M269.96 263.328H283.528V259.272L269.448 259.008L269.96 263.328Z",
    fill: "#5E7CE2"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M269.96 263.328H283.528V259.272L269.448 259.008L269.96 263.328Z",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M244 129.64H277.6V133.64L243.568 133.224L244 129.64Z",
    fill: "#141E30"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M266.8 127.84H265.6V134.944H266.8V127.84Z",
    fill: "#5E7CE2"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M249.8 127.84H248.6V134.944H249.8V127.84Z",
    fill: "#5E7CE2"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.528 88C245.442 88.3485 242.381 88.8828 239.36 89.6C240.6 84.24 247.2 79.856 247.2 79.856L248.528 88Z",
    fill: "#141E30"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M259.32 128.936H253.104V133.416H259.32V128.936Z",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M284.376 74.48C284.376 74.48 283.36 79.584 282.12 87C281.56 90.368 280.952 94.2 280.368 98.272C278.864 108.768 277.536 120.672 277.656 129.64H244C244 129.64 241.816 92.128 247.328 71.488C247.328 71.488 268.56 70.488 284.376 74.48Z",
    fill: "#141E30"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M272.304 72.24C269.24 75.024 261.736 73.992 261.736 73.992C261.736 73.992 257.048 72.712 258.032 71.248C260.792 70.792 262.128 69.504 262.68 67.856C262.982 66.8344 263.077 65.7628 262.96 64.704C262.914 64.1136 262.836 63.5261 262.728 62.944L272 56.072C270.792 60.608 269.304 68.952 272.304 72.24Z",
    fill: "#FBCFBD"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M269.864 60.44C269.496 66.04 264.92 67.544 262.664 67.856C262.966 66.8345 263.061 65.7629 262.944 64.704L269.864 60.44Z",
    fill: "#141E30"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M270.936 68.704L262.064 72.704L261.544 69.504L258.288 70.656C257.717 70.8523 257.23 71.2375 256.907 71.748C256.584 72.2585 256.445 72.8637 256.512 73.464L256.872 76.976L261.376 74.52L263.616 77.72L274.272 72.592L270.936 68.704Z",
    fill: "#141E30"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M270.936 68.704L262.064 72.704L261.544 69.504L258.288 70.656C257.717 70.8523 257.23 71.2375 256.907 71.748C256.584 72.2585 256.445 72.8637 256.512 73.464L256.872 76.976L261.376 74.52L263.616 77.72L274.272 72.592L270.936 68.704Z",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M280.928 73.704C280.928 73.704 273.08 100.104 280.008 104.84C280.008 104.84 279.048 126.552 277.664 129.64C266.45 130.237 255.212 130.224 244 129.6C243.095 121.38 242.739 113.108 242.936 104.84C242.936 104.84 245.464 101.64 245.464 99.24C245.464 96.84 246.928 77.584 251.728 71.184H254.4C254.4 71.184 250.536 79.048 251.064 85.984C251.064 85.984 262.8 87.984 271.336 86.784C271.336 86.784 273.864 77.448 276.664 72.784L280.928 73.704Z",
    fill: "#5E7CE2"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M249.8 106.44H269.6C269.6 106.44 270.8 122.704 257.184 121.64C246.776 120.8 249.8 106.44 249.8 106.44Z",
    fill: "#141E30"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 41.4C256.384 41.4 253.736 49.76 257.76 53.768C261.784 57.776 264.296 41.832 264.296 41.832L256.384 41.4Z",
    fill: "#141E30"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M271.104 61.112C270.75 61.6625 270.342 62.1769 269.888 62.648C268.711 63.9051 267.155 64.7422 265.457 65.0311C263.76 65.3201 262.014 65.045 260.488 64.248C258.498 63.2501 256.96 61.5349 256.184 59.448C256.073 59.1607 255.979 58.8668 255.904 58.568C255.715 57.8311 255.574 57.0829 255.48 56.328C254.752 50.776 255.968 43.4 261.288 41.128C262.316 40.6828 263.422 40.4451 264.542 40.4287C265.663 40.4122 266.775 40.6173 267.816 41.0321C268.857 41.4469 269.805 42.0633 270.607 42.8459C271.409 43.6284 272.048 44.5616 272.488 45.592C273.024 46.8202 273.257 48.159 273.168 49.496C272.92 54.8 272.968 58.232 271.104 61.112Z",
    fill: "#FBCFBD"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M268.488 41.816L268.056 44.552C268.522 44.7895 268.878 45.1966 269.052 45.6893C269.227 46.182 269.205 46.7227 268.992 47.2C268.024 49.48 269.216 53.104 270.936 54.592C270.936 54.592 271.024 53.6 271.856 53.864C272.688 54.128 272.28 59.328 270.552 61.752C270.552 61.752 273.12 59.592 274.712 54.176C276.184 49.168 276.496 44.96 275.512 42.976L268.488 41.816Z",
    fill: "#141E30"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4 43.72C275.4 43.72 278.176 39.432 270.704 37.176C263.232 34.92 258.032 38.128 258.032 38.128C258.032 38.128 253.168 43.936 259.632 44.88C265.976 45.808 275.4 43.72 275.4 43.72Z",
    fill: "#141E30"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M276.504 54.688C276.172 55.3913 275.705 56.0219 275.128 56.5437C274.551 57.0654 273.877 57.4679 273.144 57.728C271.184 58.416 270.072 56.696 270.504 54.768C270.896 53.064 272.384 50.592 274.416 50.768C276.448 50.944 277.312 52.936 276.504 54.688Z",
    fill: "#FBCFBD"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M272.344 44.32C272.344 44.32 270.168 65.032 259.648 63.664L260.912 64.52C260.912 64.52 270.368 65.872 273.712 44.52L272.344 44.32Z",
    fill: "#141E30"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M272.344 44.32C272.344 44.32 270.168 65.032 259.648 63.664L260.912 64.52C260.912 64.52 270.368 65.872 273.712 44.52L272.344 44.32Z",
    fill: "#141E30"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M277.408 46.064C274.304 45.264 264.2 46.944 259.448 46.744C254.696 46.544 253.152 45.76 252.376 45.088C251.6 44.416 254.448 43.488 254.448 43.488C254.448 43.488 254.824 36.288 260.728 33C262.525 32.03 264.52 31.4828 266.56 31.4C268.107 31.2614 269.666 31.4356 271.144 31.912C278.28 34.312 277.736 43.912 277.736 43.912C277.736 43.912 280.52 46.816 277.408 46.064Z",
    fill: "#5E7CE2"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.408 46.064C274.304 45.264 264.2 46.944 259.448 46.744C254.696 46.544 253.152 45.76 252.376 45.088C251.6 44.416 254.448 43.488 254.448 43.488C254.448 43.488 257.416 45.52 260.456 44.944C263.496 44.368 272.256 41.976 277.744 43.92C277.744 43.952 280.52 46.816 277.408 46.064Z",
    fill: "#141E30"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.152 31.912C268.12 32.4 265.552 35.192 264.4 37.8C262.848 41.264 257.432 45.144 258.128 37.488C258.207 36.5998 258.481 35.7399 258.931 34.9697C259.38 34.1995 259.994 33.5379 260.728 33.032C262.525 32.062 264.52 31.5148 266.56 31.432C268.107 31.282 269.669 31.4453 271.152 31.912Z",
    fill: "#141E30"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M227.496 93.832L222.232 81.592L219.944 83.256L224.184 94.472L227.496 93.832Z",
    fill: "#141E30"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.496 93.832L222.232 81.592L219.944 83.256L224.184 94.472L227.496 93.832Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M218.032 50C218.032 50 217.736 52.248 218.664 52.472C220.322 52.947 222.012 53.3052 223.72 53.544C224.52 53.504 225.064 50.344 225.064 50C225.064 49.656 218.728 47.688 218.032 50Z",
    fill: "#5E7CE2"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M218.032 50C218.032 50 217.736 52.248 218.664 52.472C220.322 52.947 222.012 53.3052 223.72 53.544C224.52 53.504 225.064 50.344 225.064 50C225.064 49.656 218.728 47.688 218.032 50Z",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.12 87C281.56 90.368 280.952 94.2 280.368 98.272C277.728 93.416 279.832 85.336 279.832 85.336L282.12 87Z",
    fill: "#141E30"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M284.376 74.48C284.376 74.48 289.104 76.08 305.864 103.504L296.2 109.44C296.2 109.44 284.104 92.8561 280.928 92.0401C280.928 92.0401 276.952 78.336 284.376 74.48Z",
    fill: "#141E30"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M305.4 101.776L294.504 109.44L296.6 111.336L306.704 104.88L305.4 101.776Z",
    fill: "#141E30"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M305.4 101.776L294.504 109.44L296.6 111.336L306.704 104.88L305.4 101.776Z",
    fill: "white"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M43.856 278.016H49.64L62.976 157.352H57.192L43.856 278.016Z",
    fill: "#141E30"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.304 190.496L54.672 232.28L49.64 277.64H43.856L48.888 232.248L53.96 186.44H53.968L59.304 190.496Z",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 278.016H144.984L158.32 157.352H152.544L139.208 278.016Z",
    fill: "#141E30"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.376 256.224L144.984 277.64H139.208L142.04 252.136L147.376 256.224Z",
    fill: "white"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8879 232.504H150.056L163.896 107.28H62.7279L48.8879 232.504Z",
    fill: "#141E30"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.4 232.84H48.8879L53.9679 186.728L59.3039 190.808L115.4 232.84Z",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M183.096 278.016H177.312L163.976 157.352H169.752L183.096 278.016Z",
    fill: "#141E30"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M183.096 278.016H177.312L163.976 157.352H169.752L183.096 278.016Z",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7441 278.016H81.9681L68.6321 157.352H74.4081L87.7441 278.016Z",
    fill: "#141E30"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.7441 278.016H81.9681L68.6321 157.352H74.4081L87.7441 278.016Z",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M178.064 232.504H76.8959L63.0559 107.28H164.224L178.064 232.504Z",
    fill: "#5E7CE2"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M178.064 232.504H76.8959L63.0559 107.28H164.224L178.064 232.504Z",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M164.192 107.24L165.432 118.44H64.304L63.064 107.24H164.192Z",
    fill: "#5E7CE2"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.192 107.24L165.432 118.44H64.304L63.064 107.24H164.192Z",
    fill: "white"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3359 107.24L70.1679 118.384L70.1599 118.44H66.7839L66.7919 118.384L68.9599 107.24H72.3359Z",
    fill: "#141E30"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M82.936 107.24L80.76 118.384L80.752 118.44H77.376L77.384 118.384L79.56 107.24H82.936Z",
    fill: "#141E30"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5281 107.24L91.3601 118.384L91.3521 118.44H87.9761L87.9841 118.384L90.1521 107.24H93.5281Z",
    fill: "#141E30"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M104.128 107.24L101.952 118.384L101.944 118.44H98.5759L98.5919 118.384L100.76 107.24H104.128Z",
    fill: "#141E30"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M114.728 107.24L112.56 118.384L112.552 118.44H109.176L109.184 118.384L111.352 107.24H114.728Z",
    fill: "#141E30"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M125.328 107.24L123.152 118.384L123.144 118.44H119.776L119.784 118.384L121.952 107.24H125.328Z",
    fill: "#141E30"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M135.92 107.24L133.752 118.384L133.744 118.44H130.376L130.384 118.384L132.552 107.24H135.92Z",
    fill: "#141E30"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M146.528 107.24L144.352 118.384L144.344 118.44H140.976L140.984 118.384L143.152 107.24H146.528Z",
    fill: "#141E30"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M157.12 107.24L154.952 118.384L154.944 118.44H151.568L151.576 118.384L153.752 107.24H157.12Z",
    fill: "#141E30"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M164.336 108.528L165.432 118.44H162.192L164.336 108.528Z",
    fill: "#141E30"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9522 232.84L75.7122 221.64H176.84L178.072 232.84H76.9522Z",
    fill: "#5E7CE2"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.9522 232.84L75.7122 221.64H176.84L178.072 232.84H76.9522Z",
    fill: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M168.808 232.84L170.976 221.696L170.984 221.64H174.36L174.352 221.696L172.176 232.84H168.808Z",
    fill: "#141E30"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M158.208 232.84L160.384 221.696L160.392 221.64H163.76L163.752 221.696L161.584 232.84H158.208Z",
    fill: "#141E30"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M147.616 232.84L149.784 221.696L149.792 221.64H153.168L153.16 221.696L150.984 232.84H147.616Z",
    fill: "#141E30"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M137.016 232.84L139.192 221.696L139.2 221.64H142.56L142.552 221.696L140.384 232.84H137.016Z",
    fill: "#141E30"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M126.416 232.84L128.584 221.696L128.592 221.64H131.968L131.96 221.696L129.784 232.84H126.416Z",
    fill: "#141E30"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M115.816 232.84L117.992 221.696L118 221.64H121.368L121.36 221.696L119.192 232.84H115.816Z",
    fill: "#141E30"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M105.224 232.84L107.392 221.696L107.4 221.64H110.768L110.76 221.696L108.584 232.84H105.224Z",
    fill: "#141E30"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M94.616 232.84L96.784 221.696L96.8 221.64H100.168L100.16 221.696L97.992 232.84H94.616Z",
    fill: "#141E30"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0242 232.84L86.1922 221.696L86.2002 221.64H89.5762L89.5602 221.696L87.3922 232.84H84.0242Z",
    fill: "#141E30"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8082 231.552L75.7122 221.64H78.9522L76.8082 231.552Z",
    fill: "#141E30"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M102.104 152.16L93.824 171.688L95.888 194.944L84.656 212.04H87.064L99.48 196.736L101.224 181.744L111.64 196.832L110.552 212.04H113.072L115.72 193.528L106.368 174.008L113.424 160.816L102.104 152.16Z",
    fill: "#5E7CE2"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M106.664 157.672C106.664 157.672 108.312 149.152 111.648 148.336C112.832 148.048 117.008 152.08 116.984 154.92C116.96 157.76 108 159.368 108 159.368L106.664 157.672Z",
    fill: "#5E7CE2"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M102.104 152.16C102.104 152.16 91.9522 151.36 90.5362 151.776C89.1202 152.192 90.1842 162.592 90.1842 162.592L91.8642 163.048C91.8642 163.048 91.7602 154.48 92.2722 154.488C92.7841 154.496 101.528 157.008 101.528 157.008L102.104 152.16Z",
    fill: "#5E7CE2"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M113.432 160.8C114.576 161.648 111.032 176.096 111.032 176.096L114.512 183.664L113.712 184.168C113.712 184.168 108.696 177.768 108.112 176.368C106.928 173.6 109.104 164.144 109.104 164.144L113.432 160.8Z",
    fill: "#5E7CE2"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M129.096 197.88L129.944 196.696L79.7359 151.064L78.8879 152.248L129.096 197.88Z",
    fill: "#5E7CE2"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M129.744 193.688L126.768 197.416C126.768 197.416 130.96 201.952 134.44 201.688C134.44 201.688 134.4 198.352 129.744 193.688Z",
    fill: "#5E7CE2"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M113.776 182.976C113.776 182.976 116.688 183.84 116.56 184.616C116.432 185.392 115.992 186.616 115.496 186.688C115 186.76 113.68 184.152 113.68 184.152L113.776 182.976Z",
    fill: "#5E7CE2"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M90.32 161.664C90.32 161.664 89.856 163.016 91.352 164.552C92.848 166.088 93.496 164.552 93.496 164.552L90.32 161.664Z",
    fill: "#5E7CE2"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4319 212.04H166.4L161.696 209.792C161.696 209.792 157.112 201.872 154.624 200.072C152.136 198.272 147.128 193.976 145.512 193.712C143.896 193.448 143.304 190.232 141.744 190.232C140.184 190.232 132.408 201.704 132.408 201.704C131.62 202.899 130.569 203.897 129.336 204.624C127.648 205.424 124.816 209.8 124.816 209.8C124.816 209.8 99.3039 210.44 80.4319 212.04Z",
    fill: "#5E7CE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.104 152.16L93.8238 171.688L95.8878 194.944L84.6558 212.04H87.0638L99.4798 196.736L101.224 181.744L111.64 196.832L110.552 212.04H113.072L115.72 193.528L106.368 174.008L113.424 160.816L102.104 152.16Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.664 157.672C106.664 157.672 108.312 149.152 111.648 148.336C112.832 148.048 117.008 152.08 116.984 154.92C116.96 157.76 108 159.368 108 159.368L106.664 157.672Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.104 152.16C102.104 152.16 91.9519 151.36 90.5359 151.776C89.1199 152.192 90.1839 162.592 90.1839 162.592L91.8639 163.048C91.8639 163.048 91.7599 154.48 92.2719 154.488C92.7839 154.496 101.528 157.008 101.528 157.008L102.104 152.16Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.432 160.8C114.576 161.648 111.032 176.096 111.032 176.096L114.512 183.664L113.712 184.168C113.712 184.168 108.696 177.768 108.112 176.368C106.928 173.6 109.104 164.144 109.104 164.144L113.432 160.8Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.096 197.88L129.944 196.696L79.7359 151.064L78.8879 152.248L129.096 197.88Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M129.744 193.688L126.768 197.416C126.768 197.416 130.96 201.952 134.44 201.688C134.44 201.688 134.4 198.352 129.744 193.688Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.776 182.976C113.776 182.976 116.688 183.84 116.56 184.616C116.432 185.392 115.992 186.616 115.496 186.688C115 186.76 113.68 184.152 113.68 184.152L113.776 182.976Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.32 161.664C90.32 161.664 89.856 163.016 91.352 164.552C92.848 166.088 93.496 164.552 93.496 164.552L90.32 161.664Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M80.4321 212.04H166.4L161.696 209.792C161.696 209.792 157.112 201.872 154.624 200.072C152.136 198.272 147.128 193.976 145.512 193.712C143.896 193.448 143.304 190.232 141.744 190.232C140.184 190.232 132.408 201.704 132.408 201.704C131.62 202.899 130.569 203.897 129.336 204.624C127.648 205.424 124.816 209.8 124.816 209.8C124.816 209.8 99.3041 210.44 80.4321 212.04Z",
    fill: "#141E30",
    fillOpacity: 0.5
  }))), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M208.304 254.44L200.4 264.584L197.568 264.16L205.904 254.44H208.304Z",
    fill: "#5E7CE2"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M208.304 254.44L200.4 264.584L197.568 264.16L205.904 254.44H208.304Z",
    fill: "#141E30"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M205.904 244.84L198 254.984L195.168 254.56L203.504 244.84H205.904Z",
    fill: "#5E7CE2"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M205.904 244.84L198 254.984L195.168 254.56L203.504 244.84H205.904Z",
    fill: "#141E30"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M183.176 239.64H149.04L157.048 260.784H191.184L183.176 239.64Z",
    fill: "#5E7CE2"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M183.176 239.64H149.04L157.048 260.784H191.184L183.176 239.64Z",
    fill: "#141E30"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M209.68 252.776H155.448V255.504H209.68V252.776Z",
    fill: "#5E7CE2"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.264 252.776H155.448V255.504H176.264V252.776Z",
    fill: "#141E30"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M206.48 244.776H152.248V247.504H206.48V244.776Z",
    fill: "#5E7CE2"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.064 244.776H152.248V247.504H173.064V244.776Z",
    fill: "#141E30"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M149.096 239.784L147.2 241.984L154.4 260.84H157.216L149.096 239.784Z",
    fill: "#5E7CE2"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M223.352 250.84L227.016 251.744C226.875 250.753 226.453 249.823 225.801 249.063C225.149 248.304 224.294 247.746 223.336 247.456C222.19 247.192 220.987 247.35 219.948 247.901C218.91 248.452 218.104 249.359 217.68 250.456C217.364 251.215 217.278 252.049 217.432 252.856L195.344 266.152C192.752 263.976 189.688 265.608 188.424 267.384L192.072 268.272C192.289 268.31 192.497 268.393 192.68 268.515C192.864 268.638 193.021 268.797 193.14 268.982C193.26 269.168 193.339 269.376 193.374 269.594C193.409 269.812 193.399 270.035 193.343 270.249C193.288 270.463 193.189 270.663 193.053 270.836C192.916 271.01 192.745 271.153 192.551 271.258C192.356 271.362 192.142 271.425 191.922 271.443C191.702 271.46 191.481 271.432 191.272 271.36L187.608 270.448C187.75 271.44 188.171 272.371 188.823 273.131C189.475 273.892 190.33 274.452 191.288 274.744C192.43 275.032 193.637 274.901 194.689 274.374C195.742 273.846 196.571 272.959 197.024 271.872C197.359 271.165 197.474 270.373 197.352 269.6L219.44 256.304C221.616 257.8 225.04 256.72 226.28 254.944L222.592 253.992C222.384 253.943 222.188 253.854 222.016 253.728C221.843 253.603 221.697 253.444 221.587 253.261C221.477 253.079 221.404 252.876 221.373 252.665C221.343 252.454 221.354 252.239 221.408 252.032C221.456 251.825 221.544 251.63 221.668 251.458C221.792 251.286 221.949 251.14 222.13 251.029C222.311 250.918 222.512 250.844 222.722 250.812C222.932 250.779 223.146 250.789 223.352 250.84Z",
    fill: "#5E7CE2"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M223.352 250.84L227.016 251.744C226.875 250.753 226.453 249.823 225.801 249.063C225.149 248.304 224.294 247.746 223.336 247.456C222.19 247.192 220.987 247.35 219.948 247.901C218.91 248.452 218.104 249.359 217.68 250.456C217.364 251.215 217.278 252.049 217.432 252.856L195.344 266.152C192.752 263.976 189.688 265.608 188.424 267.384L192.072 268.272C192.289 268.31 192.497 268.393 192.68 268.515C192.864 268.638 193.021 268.797 193.14 268.982C193.26 269.168 193.339 269.376 193.374 269.594C193.409 269.812 193.399 270.035 193.343 270.249C193.288 270.463 193.189 270.663 193.053 270.836C192.916 271.01 192.745 271.153 192.551 271.258C192.356 271.362 192.142 271.425 191.922 271.443C191.702 271.46 191.481 271.432 191.272 271.36L187.608 270.448C187.75 271.44 188.171 272.371 188.823 273.131C189.475 273.892 190.33 274.452 191.288 274.744C192.43 275.032 193.637 274.901 194.689 274.374C195.742 273.846 196.571 272.959 197.024 271.872C197.359 271.165 197.474 270.373 197.352 269.6L219.44 256.304C221.616 257.8 225.04 256.72 226.28 254.944L222.592 253.992C222.384 253.943 222.188 253.854 222.016 253.728C221.843 253.603 221.697 253.444 221.587 253.261C221.477 253.079 221.404 252.876 221.373 252.665C221.343 252.454 221.354 252.239 221.408 252.032C221.456 251.825 221.544 251.63 221.668 251.458C221.792 251.286 221.949 251.14 222.13 251.029C222.311 250.918 222.512 250.844 222.722 250.812C222.932 250.779 223.146 250.789 223.352 250.84Z",
    fill: "white"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M216.088 260.784H157.048V278.024H216.088V260.784Z",
    fill: "#5E7CE2"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.264 260.784H157.048V278.024H180.264V260.784Z",
    fill: "#141E30"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M136.312 273.656L133.648 270.984C133.251 271.909 133.128 272.927 133.293 273.92C133.457 274.912 133.902 275.837 134.576 276.584C135.423 277.401 136.536 277.886 137.711 277.95C138.885 278.015 140.044 277.655 140.976 276.936C141.636 276.452 142.14 275.784 142.424 275.016L168.2 275.056C169.296 278.256 172.768 278.44 174.768 277.576L172.096 274.928C171.924 274.785 171.784 274.608 171.685 274.408C171.586 274.208 171.53 273.99 171.52 273.767C171.51 273.544 171.547 273.321 171.629 273.113C171.71 272.906 171.835 272.717 171.993 272.56C172.152 272.403 172.342 272.281 172.55 272.202C172.759 272.122 172.982 272.088 173.205 272.1C173.428 272.112 173.646 272.17 173.845 272.272C174.044 272.373 174.219 272.515 174.36 272.688L177.032 275.36C177.427 274.435 177.55 273.415 177.384 272.423C177.218 271.431 176.771 270.506 176.096 269.76C175.268 268.921 174.165 268.408 172.99 268.315C171.814 268.223 170.645 268.557 169.696 269.256C169.044 269.687 168.539 270.306 168.248 271.032L142.464 270.992C141.368 268.592 137.904 267.792 135.904 268.592L138.568 271.312C138.72 271.461 138.841 271.639 138.924 271.835C139.007 272.032 139.049 272.243 139.049 272.456C139.049 272.669 139.007 272.88 138.924 273.077C138.841 273.273 138.72 273.451 138.568 273.6C138.276 273.906 137.874 274.083 137.452 274.093C137.029 274.104 136.619 273.947 136.312 273.656Z",
    fill: "#5E7CE2"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M136.312 273.656L133.648 270.984C133.251 271.909 133.128 272.927 133.293 273.92C133.457 274.912 133.902 275.837 134.576 276.584C135.423 277.401 136.536 277.886 137.711 277.95C138.885 278.015 140.044 277.655 140.976 276.936C141.636 276.452 142.14 275.784 142.424 275.016L168.2 275.056C169.296 278.256 172.768 278.44 174.768 277.576L172.096 274.928C171.924 274.785 171.784 274.608 171.685 274.408C171.586 274.208 171.53 273.99 171.52 273.767C171.51 273.544 171.547 273.321 171.629 273.113C171.71 272.906 171.835 272.717 171.993 272.56C172.152 272.403 172.342 272.281 172.55 272.202C172.759 272.122 172.982 272.088 173.205 272.1C173.428 272.112 173.646 272.17 173.845 272.272C174.044 272.373 174.219 272.515 174.36 272.688L177.032 275.36C177.427 274.435 177.55 273.415 177.384 272.423C177.218 271.431 176.771 270.506 176.096 269.76C175.268 268.921 174.165 268.408 172.99 268.315C171.814 268.223 170.645 268.557 169.696 269.256C169.044 269.687 168.539 270.306 168.248 271.032L142.464 270.992C141.368 268.592 137.904 267.792 135.904 268.592L138.568 271.312C138.72 271.461 138.841 271.639 138.924 271.835C139.007 272.032 139.049 272.243 139.049 272.456C139.049 272.669 139.007 272.88 138.924 273.077C138.841 273.273 138.72 273.451 138.568 273.6C138.276 273.906 137.874 274.083 137.452 274.093C137.029 274.104 136.619 273.947 136.312 273.656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstraction);
export default __webpack_public_path__ + "static/media/constraction.6a68e920.svg";
export { ForwardRef as ReactComponent };